const adapterTypeList = [
  {
    name: 'Unterstützungsring SRT',
    value: '42050',
    productKey: '91948',
    customizedNumber: '42050',
  },
  {
    name: 'Winkelanschluss SRT M30x1,5',
    value: '42051',
    productKey: '7300-00.700',
    customizedNumber: '42051',
  },
  {
    name: 'Spindelverlängerung Ventil SRT 20mm',
    value: '42052',
    productKey: '2201-20.700',
    customizedNumber: '42052',
  },
  {
    name: 'Spindelverlängerung Ventil SRT 30mm',
    value: '42053',
    productKey: '2201-30.700',
    customizedNumber: '42053',
  },
  {
    name: '20mm Danfoss RA',
    value: '42054',
    productKey: '9702-24.700',
    customizedNumber: '42054',
  },
  {
    name: '34mm Danfoss RAV',
    value: '42055',
    productKey: '9800-24.700',
    customizedNumber: '42055',
  },
  {
    name: '26mm Danfoss RAVL',
    value: '42056',
    productKey: '9700-24.700',
    customizedNumber: '42056',
  },
  {
    name: '30,5mm Vaillant',
    value: '42057',
    productKey: '9700-27.700',
    customizedNumber: '42057',
  },
  {
    name: 'M28x1,5 TA',
    value: '42058',
    productKey: '9701-28.700',
    customizedNumber: '42058',
  },
  {
    name: 'M28x1,5 Herz',
    value: '42059',
    productKey: '9700-30.700',
    customizedNumber: '42059',
  },
  {
    name: 'M28x1,5 Markaryd',
    value: '42060',
    productKey: '9700-41.700',
    customizedNumber: '42060',
  },
  {
    name: 'M28x1,5 Comap',
    value: '42061',
    productKey: '9700-55.700',
    customizedNumber: '42061',
  },
  {
    name: '22,6mm Giacomini',
    value: '42062',
    productKey: '9700-33.700',
    customizedNumber: '42062',
  },
  {
    name: 'M30x1,0 Oventrop',
    value: '42063',
    productKey: '9700-10.700',
    customizedNumber: '42063',
  },
  {
    name: 'M32x1,0 Ista',
    value: '42064',
    productKey: '9700-36.700',
    customizedNumber: '42064',
  },
  {
    name: 'Uponor(Velta)',
    value: '42065',
    productKey: '9700-34.700',
    customizedNumber: '42065',
  },
  {
    name: 'Uponor(Velta) Provario',
    value: '42066',
    productKey: '9701-34.700',
    customizedNumber: '42066',
  },
  {
    name: 'M20x1 Heimeier S2',
    value: '42067',
    productKey: '9703-24.700',
    customizedNumber: '42067',
  },
  {
    name: 'M23x1,5 Heimeier S3',
    value: '42068',
    productKey: '9704-24.700',
    customizedNumber: '42068',
  },
  {
    name: 'M20 AG 5,5mm Gampper',
    value: '42069',
    productKey: '110216',
    customizedNumber: '42069',
  },
  {
    name: 'M20 AG 7,5mm Gampper',
    value: '42070',
    productKey: '110217',
    customizedNumber: '42070',
  },
  {
    name: 'M22 Gampper',
    value: '42071',
    productKey: '110218',
    customizedNumber: '42071',
  },
  {
    name: 'M38x1,5 Meges',
    value: '42072',
    productKey: '102671',
    customizedNumber: '42072',
  },
  {
    name: 'M38x1,5 Ondal',
    value: '42073',
    productKey: '86585',
    customizedNumber: '42073',
  },
  {
    name: 'M28x1,5 PaM/Remagg/Sam',
    value: '42074',
    productKey: '76030',
    customizedNumber: '42074',
  },
  {
    name: 'M33x2,0 Rossweiner',
    value: '42076',
    productKey: '86584',
    customizedNumber: '42076',
  },
];

const submeteringDeviceMappingList = [
  {
    productKey: 'HMXIK001 002',
    customizedNumber: '4301',
    type: 'ZUBE',
    name: 'Einbausatz K R¾" x G¾" 110 mm KH-D',
  },
  {
    productKey: 'HMXIK001 004',
    customizedNumber: '4303',
    type: 'ZUBE',
    name: 'Einbausatz K R1" x G1" 130 mm KH-D',
  },
  {
    productKey: 'HMXIK001 005',
    customizedNumber: '4304',
    type: 'ZUBE',
    name: 'Einbausatz K R¾" x G1" 130 mm KH-D',
  },
  {
    productKey: 'HMXIK001 001',
    customizedNumber: '4305',
    type: 'ZUBE',
    name: 'Einbausatz K R½" x G¾" 110 mm KH-D',
  },
  {
    productKey: 'G98000102 0',
    customizedNumber: '4389',
    type: 'WMZ',
    name: 'Tauchhülse 85mm (105mm)',
  },
  {
    productKey: 'G98000103 0',
    customizedNumber: '4390',
    type: 'ZUBE',
    name: 'TF-Einbausatz / Qn 15,0 bis 250,0 / TH',
  },
  {
    productKey: 'G98000201 0',
    customizedNumber: '4391',
    type: 'ZUBE',
    name: 'VMT-Einbausatz / Qn 0,6 bis 1,5',
  },
  {
    productKey: 'G98000202 0',
    customizedNumber: '4392',
    type: 'ZUBE',
    name: 'VMT-Einbausatz / Qn 2,5',
  },
  {
    productKey: 'G98000203 0',
    customizedNumber: '4393',
    type: 'ZUBE',
    name: 'VMT-Einbausatz / Qn 3,5 bis 6,0',
  },
  {
    productKey: 'G98000204 0',
    customizedNumber: '4394',
    type: 'ZUBE',
    name: 'VMT-Einbausatz / Qn 10,0',
  },
  {
    productKey: 'G98001101 0',
    customizedNumber: '4396',
    type: 'ZUBE',
    name: 'TF-Einbausatz R1 Qn 0,6 bis 2,5 / KH',
  },
  {
    productKey: 'G98001104 0',
    customizedNumber: '4399',
    type: 'ZUBE',
    name: 'TF-Einbausatz R¾ Qn 0,6 bis 2,5 / KH',
  },
  {
    productKey: 'G98001105 0',
    customizedNumber: '4400',
    type: 'ZUBE',
    name: 'TF-Einbausatz R½, qp 0,6-2,5',
  },
  {
    productKey: '50595002H 4',
    customizedNumber: '4404',
    type: 'WMZ',
    name: 'US-VMT qp 1,5 bel. G1 130mm 0,1l/Imp',
  },
  {
    productKey: '50594589H 4',
    customizedNumber: '4407',
    type: 'WMZ',
    name: 'US-VMT qp 2,5 bel. G1 130mm 0,1l/Imp',
  },
  {
    productKey: '50594588H 4',
    customizedNumber: '4409',
    type: 'WMZ',
    name: 'US-VMT qp 1,5 bel. G¾ 110mm 0,1l/Imp',
  },
  {
    productKey: '50594587H 4',
    customizedNumber: '4411',
    type: 'WMZ',
    name: 'US-VMT qp 0,6 bel. G¾ 110mm 0,1l/Imp',
  },
  {
    productKey: '50595004H 4',
    customizedNumber: '4413',
    type: 'WMZ',
    name: 'US-VMT qp 2,5 bel. G1 190mm 0,1l/Imp',
  },
  {
    productKey: '50595000H 4',
    customizedNumber: '4414',
    type: 'WMZ',
    name: 'US-VMT qp 0,6 bel. G1 130mm 0,1l/Imp',
  },
  {
    productKey: '50594587H 5',
    customizedNumber: '4416',
    type: 'WMZ',
    name: 'VMT-US qp0,6 110-G¾ H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50595000H 5',
    customizedNumber: '4417',
    type: 'WMZ',
    name: 'VMT-US qp0,6 130-G1 H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50594588H 5',
    customizedNumber: '4418',
    type: 'WMZ',
    name: 'VMT-US qp1,5 110-G¾ H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50595002H 5',
    customizedNumber: '4419',
    type: 'WMZ',
    name: 'VMT-US qp1,5 130-G1 H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50595006H 4',
    customizedNumber: '4420',
    type: 'WMZ',
    name: 'US-VMT qp 3,5 bel. G5/4 150mm 1l/Imp',
  },
  {
    productKey: '599984K',
    customizedNumber: '4421',
    type: 'WMZ',
    name: 'VMT-US qp3,5 150-G1¼ H/V 0,5l AMS',
  },
  {
    productKey: '50595003H 5',
    customizedNumber: '4424',
    type: 'WMZ',
    name: 'VMT-US qp1,5 190-G1 H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50594589H 5',
    customizedNumber: '4426',
    type: 'WMZ',
    name: 'VMT-US qp2,5 130-G1 H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50595004H 5',
    customizedNumber: '4427',
    type: 'WMZ',
    name: 'VMT-US qp2,5 190-G1 H/V 0,1l PN25 DIE',
  },
  {
    productKey: '50595008H 4',
    customizedNumber: '4428',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. G5/4 150mm 1l/Imp',
  },
  {
    productKey: '50595009H 4',
    customizedNumber: '4431',
    type: 'WMZ',
    name: 'US-VMT qp 10,0 bel. G2 200mm 1l/Imp',
  },
  {
    productKey: '50595005H 5',
    customizedNumber: '4432',
    type: 'WMZ',
    name: 'VMT-US qp3,5 135-G1¼ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595006H 5',
    customizedNumber: '4433',
    type: 'WMZ',
    name: 'VMT-US qp3,5 150-G1¼ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595019H 5',
    customizedNumber: '4434',
    type: 'WMZ',
    name: 'VMT-US qp3,5 150-G1½ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50593182H 5',
    customizedNumber: '4435',
    type: 'WMZ',
    name: 'VMT-US qp3,5 260-G1¼ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595018H 5',
    customizedNumber: '4438',
    type: 'WMZ',
    name: 'VMT-US qp3,5 260-G1½ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50593184H 4',
    customizedNumber: '4446',
    type: 'WMZ',
    name: 'US-VMT qp 10,0 bel. G2 300mm 1l/Imp',
  },
  {
    productKey: '50593188H 4',
    customizedNumber: '4447',
    type: 'WMZ',
    name: 'US-VMT qp 3,5 bel. DN25 260mm 1l/Imp',
  },
  {
    productKey: '50595012H 4',
    customizedNumber: '4458',
    type: 'WMZ',
    name: 'US-VMT qp 2,5 bel. DN20 190mm 1l/Imp',
  },
  {
    productKey: '50593191H 5',
    customizedNumber: '4460',
    type: 'WMZ',
    name: 'US-VMT qp 15,0 bel. DN50 270mm 10l/Imp',
  },
  {
    productKey: '50593192H 5',
    customizedNumber: '4461',
    type: 'WMZ',
    name: 'US-VMT qp 25 bel. DN65 300mm 10l/Imp',
  },
  {
    productKey: '50593189H 4',
    customizedNumber: '4462',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. DN25 260mm 1l/Imp',
  },
  {
    productKey: '50595003H 4',
    customizedNumber: '4463',
    type: 'WMZ',
    name: 'US-VMT qp 1,5 bel. G1 190mm 0,1l/Imp',
  },
  {
    productKey: '50595016H 4',
    customizedNumber: '4464',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. DN32 260mm 1l/Imp',
  },
  {
    productKey: '50595017H 4',
    customizedNumber: '4465',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. G2 150mm 1l/Imp',
  },
  {
    productKey: '50595019H 4',
    customizedNumber: '4466',
    type: 'WMZ',
    name: 'US-VMT qp 3,5 bel. G6/4 150mm 1l/Imp',
  },
  {
    productKey: '50593193H 5',
    customizedNumber: '4467',
    type: 'WMZ',
    name: 'US-VMT qp 40 bel. DN80 300mm 10l/Imp',
  },
  {
    productKey: '50533149H 4',
    customizedNumber: '4468',
    type: 'WMZ',
    name: 'WMWS-VMT qp 25,0 H DN65 300mm 100l/Imp',
  },
  {
    productKey: '50595007H 5',
    customizedNumber: '4472',
    type: 'WMZ',
    name: 'VMT-US qp6,0 135-G1¼ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595008H 5',
    customizedNumber: '4473',
    type: 'WMZ',
    name: 'VMT-US qp6,0 150-G1¼ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595014H 5',
    customizedNumber: '4474',
    type: 'WMZ',
    name: 'VMT-US qp6,0 150-G1½ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595017H 5',
    customizedNumber: '4475',
    type: 'WMZ',
    name: 'VMT-US qp6,0 150-G2 H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595013H 5',
    customizedNumber: '4478',
    type: 'WMZ',
    name: 'US-VMT qp 60 bel. DN100 360mm 10l/Imp',
  },
  {
    productKey: '50593183H 5',
    customizedNumber: '4480',
    type: 'WMZ',
    name: 'VMT-US qp6,0 260-G1¼ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595015H 5',
    customizedNumber: '4481',
    type: 'WMZ',
    name: 'VMT-US qp6,0 260-G1½ H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595009H 5',
    customizedNumber: '4482',
    type: 'WMZ',
    name: 'VMT-US qp10,0 200-G2 H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50593184H 5',
    customizedNumber: '4483',
    type: 'WMZ',
    name: 'VMT-US qp10,0 300-G2 H/V 1,0l PN25 DIE',
  },
  {
    productKey: '50595014H 4',
    customizedNumber: '4485',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. G6/4 150mm 1l/Imp',
  },
  {
    productKey: '50594589H 8',
    customizedNumber: '4497',
    type: 'WMZ',
    name: 'K HEAT VMT-US qp2,5 130-G1 H/V 0,1l AMS',
  },
  {
    productKey: '50593182H 4',
    customizedNumber: '4518',
    type: 'WMZ',
    name: 'US-VMT qp 3,5 bel. G5/4 260mm 1l/Imp',
  },
  {
    productKey: '50593183H 4',
    customizedNumber: '4519',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. G5/4 260mm 1l/Imp',
  },
  {
    productKey: '50595005H 4',
    customizedNumber: '4547',
    type: 'WMZ',
    name: 'US-VMT qp 3,5 bel. G5/4 135mm 1l/Imp',
  },
  {
    productKey: '50533151H 4',
    customizedNumber: '4558',
    type: 'WMZ',
    name: 'WMWS-VMT qp 60,0 H DN100 360mm 100l/Imp',
  },
  {
    productKey: '50595007H 4',
    customizedNumber: '4559',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. G5/4 135mm 1l/Imp',
  },
  {
    productKey: '50595020H 4',
    customizedNumber: '4561',
    type: 'WMZ',
    name: 'WMWS-VMT qp 150 H DN150 500mm 100l/Imp',
  },
  {
    productKey: '50533148H 4',
    customizedNumber: '4568',
    type: 'WMZ',
    name: 'WMWS-VMT qp 15,0 H DN50 270mm 100l/Imp',
  },
  {
    productKey: '50533150H 4',
    customizedNumber: '4570',
    type: 'WMZ',
    name: 'WMWS-VMT qp 40,0 H DN80 300mm 100l/Imp',
  },
  {
    productKey: '50590987H4',
    customizedNumber: '4582',
    type: 'WMZ',
    name: 'Unical W: VMT 200.0 UF DN 150/300 mm',
  },
  {
    productKey: '50533154H 4',
    customizedNumber: '4595',
    type: 'WMZ',
    name: 'WMWP-VMT qp 32 H/V DN80 225mm 100l/Imp',
  },
  {
    productKey: '50533155H 4',
    customizedNumber: '4597',
    type: 'WMZ',
    name: 'WMWP-VMT qp 50 H/V DN100 250mm 100l/Imp',
  },
  {
    productKey: '50533152H 4',
    customizedNumber: '4599',
    type: 'WMZ',
    name: 'WMWP-VMT qp 15 H/V DN50 200mm 100l/Imp',
  },
  {
    productKey: '599991K',
    customizedNumber: '4675',
    type: 'WMZ',
    name: 'KaloUltra Control A55 0,5l Pt 500',
  },
  {
    productKey: 'FKM0049',
    customizedNumber: '4716',
    type: 'ZUBE',
    name: 'TF-Adapter M 10 x 1 direkt auf ¼"',
  },
  {
    productKey: 'FKM0039',
    customizedNumber: '4725',
    type: 'WMZ',
    name: 'Tauchhülse ¼" Deltamess',
  },
  {
    productKey: 'FKM0036',
    customizedNumber: '4730',
    type: 'ZUBE',
    name: 'Vorlauf T-Stück ¾" IG o.TH. (Qundis)',
  },
  {
    productKey: 'FKM0038',
    customizedNumber: '4733',
    type: 'WMZ',
    name: 'Tauchhülse ¼" (Qundis) 5,0mm',
  },
  {
    productKey: 'F428489140',
    customizedNumber: '4830',
    type: 'ZUBE',
    name: 'Reduzierstück ¾" auf 1"',
  },
  {
    productKey: 'FKM0021',
    customizedNumber: '4914',
    type: 'ZUBE',
    name: 'Verschraubung R ¾" x G 1"',
  },
  {
    productKey: 'FKM0019',
    customizedNumber: '4915',
    type: 'ZUBE',
    name: 'Verschraubung ¾" Baul. 60 mm (Messing)',
  },
  {
    productKey: 'FKM0020',
    customizedNumber: '4933',
    type: 'ZUBE',
    name: 'Verschraubung R 1" x G ¾"',
  },
  {
    productKey: 'FKM0069',
    customizedNumber: '4934',
    type: 'ZUBE',
    name: 'Verschraubung 1" (Messing) Baul. 70 mm',
  },
  {
    productKey: 'G98000204 0',
    customizedNumber: '4935',
    type: 'ZUBE',
    name: 'Verschraubung 1 ½" Baul. 67,5mm',
  },
  {
    productKey: 'FTF0016',
    customizedNumber: '5399',
    type: 'WMZ',
    name: 'TF-Paar 6,0x50mm 2,5m PT1000 150°C MID',
  },
  {
    productKey: 'BOZ5005',
    customizedNumber: '5457',
    type: 'ZUBE',
    name: 'Beipack direkt 5,2mm Fühler',
  },
  {
    productKey: 'FTF0018',
    customizedNumber: '5459',
    type: 'WMZ',
    name: 'TF-Paar AGFW 27mm 2,5m PT1000 150°C MID',
  },
  {
    productKey: 'FTF0025',
    customizedNumber: '5463',
    type: 'WMZ',
    name: 'TF-Paar AMS 6,0x50mm 2,5m PT1000 150°MID',
  },
  {
    productKey: 'FTF0026',
    customizedNumber: '5464',
    type: 'WMZ',
    name: 'TF-Paar 6,0x50mm  10m PT1000 150°C MID',
  },
  {
    productKey: 'FTF0027',
    customizedNumber: '5465',
    type: 'WMZ',
    name: 'TF-Paar AGFW 38mm 2,5m PT1000 150°C MID',
  },
  {
    productKey: 'FTF0028',
    customizedNumber: '5466',
    type: 'WMZ',
    name: 'TF-Paar AGFW 38mm  10m PT1000 150°C MID',
  },
  {
    productKey: 'FTF0035',
    customizedNumber: '5468',
    type: 'WMZ',
    name: 'TF-Paar universal PT1000 5,0mm 3m 150°C',
  },
  {
    productKey: 'FTF0036',
    customizedNumber: '5469',
    type: 'WMZ',
    name: 'TF-Paar universal PT1000 5,0mm 10m 150°C',
  },
  {
    productKey: 'FTF0037',
    customizedNumber: '5470',
    type: 'WMZ',
    name: 'TF-Paar universal PT1000 5,2mm 3m 150°C',
  },
  {
    productKey: 'FTF0038',
    customizedNumber: '5471',
    type: 'WMZ',
    name: 'TF-Paar universal PT1000 5,2mm 10m 150°C',
  },
  {
    productKey: 'FTF0039',
    customizedNumber: '5472',
    type: 'WMZ',
    name: 'TF-Paar universal PT1000 6,0mm 3m 150°C',
  },
  {
    productKey: 'FTF0040',
    customizedNumber: '5473',
    type: 'WMZ',
    name: 'TF-Paar universal PT1000 6,0mm 10m 150°C',
  },
  {
    productKey: '599983K',
    customizedNumber: '5486',
    type: 'WMZ',
    name: 'Unical W: TF-D AGFW 2.50m 38mm PT 500',
  },
  {
    productKey: 'FTF0028',
    customizedNumber: '5487',
    type: 'WMZ',
    name: 'Unical W: TF-D AGFW 5.0m 38mm PT 500',
  },
  {
    productKey: '50591472 4',
    customizedNumber: '5488',
    type: 'WMZ',
    name: 'TF-Paar 5,2x45mm 3,0m PT1000 150°C MID',
  },
  {
    productKey: '50591473 4',
    customizedNumber: '5507',
    type: 'WMZ',
    name: 'TF-Paar 5,2x45mm  10m PT1000 150°C MID',
  },
  {
    productKey: 'FTF0032',
    customizedNumber: '7253',
    type: 'WMZ',
    name: 'Platin TF-Paar 84mm, 6 mm PT500',
  },
  {
    productKey: 'FTF0033',
    customizedNumber: '7254',
    type: 'WMZ',
    name: 'Platin TF-Paar 174mm, 6mm PT500',
  },
  {
    productKey: 'FTF0034',
    customizedNumber: '7255',
    type: 'WMZ',
    name: 'Platin TF-Paar 134mm, 6mm PT500',
  },
  {
    productKey: 'HMR50001Q840 00000',
    customizedNumber: '7354',
    type: 'WMZ',
    name: 'kaloULTRAMAX MK Qn 1,5 Vorlauf',
  },
  {
    productKey: 'HMRH00A19A90 01000',
    customizedNumber: '7367',
    type: 'WMZ',
    name: 'kaloULTRAMAX MK Qn 2,5 DS 6 5,0 m Kabel',
  },
  {
    productKey: 'HMR500010740 00000',
    customizedNumber: '7402',
    type: 'WMZ',
    name: 'Unical Ultraheat XS Qp 0,6 m³/h,¾"/110',
  },
  {
    productKey: 'HMR500011740 00000',
    customizedNumber: '7403',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" AG 110 mm AGFW 3mtr',
  },
  {
    productKey: 'HMR50001K440 00000',
    customizedNumber: '7404',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" 110 mm 5.0 VL 3,0m',
  },
  {
    productKey: 'HMR500012740 00000',
    customizedNumber: '7405',
    type: 'WMZ',
    name: 'kaloHeat Qn 2,5 1" AG 130 mm AGFW 3mtr',
  },
  {
    productKey: 'HMR50001L740 00000',
    customizedNumber: '7406',
    type: 'WMZ',
    name: 'kaloHeat 2,5 1" AG130mm AGFW 3m VL',
  },
  {
    productKey: 'HMR500012740 00000',
    customizedNumber: '7409',
    type: 'WMZ',
    name: 'Unical Ultraheat XS Qp 2,5 m³/h130mm  FA',
  },
  {
    productKey: 'FKM0051',
    customizedNumber: '7416',
    type: 'WMZ',
    name: 'Tauchhülse M 10x1 / 5,0 / MID',
  },
  {
    productKey: 'HMR500011540 00000',
    customizedNumber: '7443',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" AG 110 mm 5.2 3mtr',
  },
  {
    productKey: 'HMR500A12190 00000',
    customizedNumber: '7499',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,2 mm',
  },
  {
    productKey: 'HMR500A12190 00000',
    customizedNumber: '7500',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,2 mm',
  },
  {
    productKey: 'HMR500A11090 00000',
    customizedNumber: '7501',
    type: 'WMZ',
    name: 'Kaloheat US Qp1,5 ¾"AG 110 mm 5,0 1,5m',
  },
  {
    productKey: 'HMR500A1K490 00000',
    customizedNumber: '7502',
    type: 'WMZ',
    name: 'kaloHeat US Qn 1,5 ¾" AG 110 mm 5,0 VL',
  },
  {
    productKey: 'HMR500A12490 00000',
    customizedNumber: '7503',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 ,5,0 mm 3 m',
  },
  {
    productKey: 'HMR500A1L490 00000',
    customizedNumber: '7504',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,0 VL',
  },
  {
    productKey: 'HMR500A11190 00000',
    customizedNumber: '7505',
    type: 'WMZ',
    name: 'kaloHeat US Qn 1,5 ¾" AG 110 mm 5,2 mm',
  },
  {
    productKey: 'HMR500A12190 00000',
    customizedNumber: '7507',
    type: 'WMZ',
    name: 'Ultramax-V, Qp2,5 ,1"AG 130 mm, Dir. 5,2',
  },
  {
    productKey: 'HMR500A1L190 00000',
    customizedNumber: '7508',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,2 VL',
  },
  {
    productKey: 'HMR500011240 00000',
    customizedNumber: '7509',
    type: 'WMZ',
    name: 'Ultramax-V, Qp1,5 ,¾"AG 110 mm, TH 6,0',
  },
  {
    productKey: 'HMR500018840 00000',
    customizedNumber: '7558',
    type: 'WMZ',
    name: 'kaloULTRAMAX MK Qn 1,5 FA Rändelmutter',
  },
  {
    productKey: 'HMR50001Q940 00000',
    customizedNumber: '7559',
    type: 'WMZ',
    name: 'kaloULTRAMAX MK Qn 1,5 DS 6 FA Vorl.',
  },
  {
    productKey: '50595011H 4',
    customizedNumber: '7614',
    type: 'WMZ',
    name: 'US-VMT qp 1,5 bel. DN20 190mm 1l/Imp',
  },
  {
    productKey: '50593190H 4',
    customizedNumber: '7877',
    type: 'WMZ',
    name: 'US-VMT qp 10,0 bel. DN40 300mm 1l/Imp',
  },
  {
    productKey: '50595018H 4',
    customizedNumber: '7879',
    type: 'WMZ',
    name: 'US-VMT qp 3,5 bel. G6/4 260mm 1l/Imp',
  },
  {
    productKey: '50595015H 4',
    customizedNumber: '7884',
    type: 'WMZ',
    name: 'US-VMT qp 6,0 bel. G6/4 260mm 1l/Imp',
  },
  {
    productKey: 'FTF0017',
    customizedNumber: '7996',
    type: 'WMZ',
    name: 'TF-Paar 5,0x45mm 3,0m PT1000 150°C MID',
  },
  {
    productKey: '599986K',
    customizedNumber: '8103',
    type: 'WMZ',
    name: 'TF-Paar Pt 500  3m Durchm.5mm',
  },
  {
    productKey: 'FTF0019',
    customizedNumber: '8108',
    type: 'WMZ',
    name: 'TF-Paar Pt 1000 AGFW 10m Fühler M 10x1',
  },
  {
    productKey: '50591477J 4',
    customizedNumber: '8503',
    type: 'WMZ',
    name: 'TF-Paar 6,0x140mm 3,0m PT1000 180°C MID',
  },
  {
    productKey: '50591475J 4',
    customizedNumber: '8511',
    type: 'WMZ',
    name: 'TF-Paar 6,0x100mm  10m PT1000 150°C MID',
  },
  {
    productKey: '50591474J 4',
    customizedNumber: '8512',
    type: 'WMZ',
    name: 'TF-Paar 6,0x105mm 3,0m PT1000 180°C MID',
  },
  {
    productKey: 'FTF0029',
    customizedNumber: '8513',
    type: 'WMZ',
    name: 'TF-Paar SPX 6,0x150mm 2,5m PT1000 150°C',
  },
  {
    productKey: 'FTF0030',
    customizedNumber: '8514',
    type: 'WMZ',
    name: 'TF-Paar SPX 6,0x150mm 10m PT1000 150°C',
  },
  {
    productKey: '50591478J 4',
    customizedNumber: '8515',
    type: 'WMZ',
    name: 'TF-Paar 6,0x140mm 10,0m PT1000 180°C MID',
  },
  {
    productKey: '50591475J 4',
    customizedNumber: '8516',
    type: 'WMZ',
    name: 'TF-Paar 6,0x105mm 10,0m PT1000 180°C MID',
  },
  {
    productKey: 'HMRIK001 001',
    customizedNumber: '8648',
    type: 'ZUBE',
    name: 'Kalo Heat Wandhalterung',
  },
  {
    productKey: 'HMR500014240 00000',
    customizedNumber: '8649',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 0,6/1,5m - 6mm',
  },
  {
    productKey: 'HMR500015240 00000',
    customizedNumber: '8650',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5/1,5m - 6mm',
  },
  {
    productKey: 'HMR500014040 00000',
    customizedNumber: '8651',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 0,6/1,5m Fühler',
  },
  {
    productKey: 'HMR500016240 00000',
    customizedNumber: '8652',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 2,5/1,5m - 6mm',
  },
  {
    productKey: 'HMR500015040 00000',
    customizedNumber: '8653',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5/1,5m Fühler',
  },
  {
    productKey: 'HMR500015440 00000',
    customizedNumber: '8654',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5 / 3,0m Fühler',
  },
  {
    productKey: 'HMR500016040 00000',
    customizedNumber: '8655',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 2,5/1,5m Fühler',
  },
  {
    productKey: 'HMR500016440 00000',
    customizedNumber: '8656',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 2,5 / 3,0m Fühler',
  },
  {
    productKey: 'HMR500015140 00000',
    customizedNumber: '8657',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5/1,5m Fühler 5,2 mm',
  },
  {
    productKey: 'HMR500014140 00000',
    customizedNumber: '8658',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 0,6/1,5m Fühler 5,2 mm',
  },
  {
    productKey: 'HMR50011N040 00000',
    customizedNumber: '8659',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5/1,5m Fühler Vorl/K',
  },
  {
    productKey: 'HMR500016640 00000',
    customizedNumber: '8660',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 2,5/3,0m - 6mm',
  },
  {
    productKey: 'HMR500115440 00000',
    customizedNumber: '8667',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5 / 3,0m  + Kälte',
  },
  {
    productKey: 'HMR500116040 00000',
    customizedNumber: '8668',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 2,5 /  Kälte',
  },
  {
    productKey: 'HMR500018840 00000',
    customizedNumber: '8686',
    type: 'WMZ',
    name: 'kaloHeat MK , Qn 1,5, Fühler DS 6',
  },
  {
    productKey: 'HMR500018140 00000',
    customizedNumber: '8687',
    type: 'WMZ',
    name: 'kaloHeat MK-S Qn 1,5',
  },
  {
    productKey: 'HMR500018840 00000',
    customizedNumber: '8688',
    type: 'WMZ',
    name: 'kaloHEAT MK Qn 1,5 HA DS 6',
  },
  {
    productKey: 'FKM0080',
    customizedNumber: '9648',
    type: 'ZUBE',
    name: 'Kugelhahn 1" IG m. Verschraubung ms',
  },
  {
    productKey: 'FKM0078',
    customizedNumber: '9661',
    type: 'ZUBE',
    name: 'Kugelhahn R1xG¾ TW',
  },
  {
    productKey: 'FKM0035',
    customizedNumber: '9662',
    type: 'ZUBE',
    name: 'T-Stück R½',
  },
  {
    productKey: 'FKM0026',
    customizedNumber: '9663',
    type: 'ZUBE',
    name: 'Kugelhahn mit TF-Aufnahme R½xG¾',
  },
  {
    productKey: 'FKM0023',
    customizedNumber: '9664',
    type: 'ZUBE',
    name: 'Kugelhahn R½ mit TF-Aufnahme M10x1',
  },
  {
    productKey: 'FKM0005',
    customizedNumber: '9665',
    type: 'ZUBE',
    name: 'Gehäuse Koax K1 ¾" AG/18mm löt / MID',
  },
  {
    productKey: 'WME.L15/OV/H',
    customizedNumber: '9666',
    type: 'ZUBE',
    name: 'EAT-Geh. Koax G½, 110mm Löt 15mm',
  },
  {
    productKey: 'FKM0007',
    customizedNumber: '9667',
    type: 'ZUBE',
    name: 'Gehäuse Koax K3 22mm löt / MID',
  },
  {
    productKey: 'FKM0008',
    customizedNumber: '9668',
    type: 'ZUBE',
    name: 'Gehäuse Koax K4 ¾" IG / MID',
  },
  {
    productKey: 'FKM0105',
    customizedNumber: '29914',
    type: 'ZUBE',
    name: 'Blindflansch Messing WKV-Kalo',
  },
  {
    productKey: 'FKS0057',
    customizedNumber: '29915',
    type: 'ZUBE',
    name: 'Dichtung Blindflansch WKV-Kalo',
  },
  {
    productKey: 'HCAIK001 002',
    customizedNumber: '34988',
    type: 'ZUBE',
    name: 'Montagesatz Glieder-HK, Teilung  =<40 mm',
  },
  {
    productKey: 'HCAIK001 003',
    customizedNumber: '34989',
    type: 'ZUBE',
    name: 'Montagesatz Guss-HK, Teilung.20/40 mm',
  },
  {
    productKey: 'HCAIK001 004',
    customizedNumber: '34990',
    type: 'ZUBE',
    name: 'Montagesatz Stirnflächen Guss-HK',
  },
  {
    productKey: 'HCAIK001 005',
    customizedNumber: '34991',
    type: 'ZUBE',
    name: 'Montagesatz Guss-Glieder-HK , Typ KR',
  },
  {
    productKey: 'HCAIK001 006',
    customizedNumber: '34992',
    type: 'ZUBE',
    name: 'Montagesatz Glieder-HK, li. W. > 40 mm',
  },
  {
    productKey: 'HCAIK001 007',
    customizedNumber: '34993',
    type: 'ZUBE',
    name: 'Montagesatz Platten-HK, plane Front',
  },
  {
    productKey: 'HCAIK002 001',
    customizedNumber: '34994',
    type: 'ZUBE',
    name: 'Montagesatz Platten-HK, senkr. Profil.',
  },
  {
    productKey: 'HCAIK003 005',
    customizedNumber: '34995',
    type: 'ZUBE',
    name: 'Montagesatz Bad-HK, Sammler einseitig',
  },
  {
    productKey: 'HCAIK006 002',
    customizedNumber: '34996',
    type: 'ZUBE',
    name: 'Montagesatz Rohrregister-HK, Kanal tief',
  },
  {
    productKey: 'HCAIK006 003',
    customizedNumber: '34997',
    type: 'ZUBE',
    name: 'Montagesatz Rohrregister-HK, horiz.',
  },
  {
    productKey: 'HCAIK007 001',
    customizedNumber: '34998',
    type: 'ZUBE',
    name: 'Montagesatz Falt(en)-Radiatoren',
  },
  {
    productKey: 'HCAIK007 003',
    customizedNumber: '34999',
    type: 'ZUBE',
    name: 'Montagesatz Flachrohr-HK',
  },
  {
    productKey: 'HCAIK007 004',
    customizedNumber: '35000',
    type: 'ZUBE',
    name: 'Montagesatz Fensterbank-Radiatoren',
  },
  {
    productKey: 'WTZ.G001',
    customizedNumber: '35045',
    type: 'ZUBE',
    name: 'FZ-Box für Außenmontagen',
  },
  {
    productKey: 'HCAIK001 001',
    customizedNumber: '35101',
    type: 'ZUBE',
    name: 'Montagesatz "Gliederheizkörper"',
  },
  {
    productKey: 'HCAIK002 004',
    customizedNumber: '35105',
    type: 'ZUBE',
    name: 'Montagesatz "Platte Frontkonv."',
  },
  {
    productKey: 'HCAIK004 001',
    customizedNumber: '35108',
    type: 'ZUBE',
    name: 'Montagesatz "Alu-Gliederheizkörper"',
  },
  {
    productKey: 'HCAIK010 005',
    customizedNumber: '35112',
    type: 'ZUBE',
    name: 'Montagesatz HK-Sensor "Platten"',
  },
  {
    productKey: 'HCAIK010 001',
    customizedNumber: '35113',
    type: 'ZUBE',
    name: 'Montagesatz HK- "Glieder"',
  },
  {
    productKey: 'FOZ0001',
    customizedNumber: '35121',
    type: 'ZUBE',
    name: 'Kabelkanal weiß - Länge 2m',
  },
  {
    productKey: 'RWM5014T0000 00000',
    customizedNumber: '35180',
    type: 'FUM',
    name: 'KB MODULE WATER 5.5 Allmess AWC',
  },
  {
    productKey: 'MWMH00020000 Z0V10',
    customizedNumber: '35187',
    type: 'MBMO',
    name: 'M-BUS MODULARIS Funkmodul',
  },
  {
    productKey: 'RML5Q2060000 S0000',
    customizedNumber: '35195',
    type: 'ZUBE',
    name: 'Q Log 5.5 Transfermodul',
  },
  {
    productKey: 'MWMHZYC20000 Z0V10',
    customizedNumber: '35197',
    type: 'MBMO',
    name: 'M-BUS Modul von Maddalena for Bulk Meter',
  },
  {
    productKey: 'RWM5KA4N0000 0000K',
    customizedNumber: '35198',
    type: 'FUM',
    name: 'Q module 5.5 water Allmess S-Mode',
  },
  {
    productKey: 'G99PKK102 0',
    customizedNumber: '35224',
    type: 'ZUBE',
    name: 'OPTOKOPF mit Adapter und Kabel (USB)',
  },
  {
    productKey: 'RWM5010T0000 00000',
    customizedNumber: '35282',
    type: 'FUM',
    name: 'KB MODULE WATER 5.5 Modularis AWC',
  },
  {
    productKey: 'RWM5KG0T0000 00000',
    customizedNumber: '35285',
    type: 'FUM',
    name: 'kaloBLUE Aufsatzmodul XWE  "G"',
  },
  {
    productKey: 'B18304-3007',
    customizedNumber: '35286',
    type: 'ZUBE',
    name: 'Schrauben XWE 10 Plomben /Schrauben',
  },
  {
    productKey: 'RWM5KG0T0000 0000L',
    customizedNumber: '35287',
    type: 'FUM',
    name: 'kaloBLUE Aufsatzmodul XWE  "G"',
  },
  {
    productKey: 'RNN5000M1100 00000',
    customizedNumber: '35417',
    type: 'FE',
    name: 'KB Netzwerkknoten Qnode5.5 netzversorgt',
  },
  {
    productKey: 'RNN5KG0M0000 01000',
    customizedNumber: '35418',
    type: 'FE',
    name: 'KB Node 5 Qnode G Netzwerkknoten',
  },
  {
    productKey: 'RNN5000M0004 04000',
    customizedNumber: '35419',
    type: 'FE',
    name: 'KB Node 5.5 Qnode Netzwerkknoten',
  },
  {
    productKey: 'FBR0018',
    customizedNumber: '35422',
    type: 'ZUBE',
    name: 'Backup Batterie Qnode5; Lithium LS14500',
  },
  {
    productKey: 'WTZ.BAT/1',
    customizedNumber: '35423',
    type: 'ZUBE',
    name: 'Hauptbatterie Qnode5 "Ersatz"',
  },
  {
    productKey: 'RNN5KA0M0000 00000',
    customizedNumber: '35425',
    type: 'FE',
    name: 'kaloBLUE Netzwerkknoten K-System s.35419',
  },
  {
    productKey: 'RNG5KA0R0050 0000',
    customizedNumber: '35426',
    type: 'FE',
    name: 'kaloBLUE Gateway K-System s.35432',
  },
  {
    productKey: 'RNG5KA0R0070 0000',
    customizedNumber: '35431',
    type: 'FE',
    name: 'kaloBLUE Gateway Qgateway V2 s.35432',
  },
  {
    productKey: 'RNG5KA2R2070',
    customizedNumber: '35432',
    type: 'FE',
    name: 'kaloBLUE Gateway Qgateway V3',
  },
  {
    productKey: 'RNG5N00R1070 00000',
    customizedNumber: '35433',
    type: 'FE',
    name: 'KB Gateway Qgateway netzversorgt UMTS',
  },
  {
    productKey: 'RNG5002T2070 1300A',
    customizedNumber: '35434',
    type: 'FE',
    name: 'kaloBLUE Direct Meter Gateway',
  },
  {
    productKey: 'RNG521.BAT',
    customizedNumber: '35439',
    type: 'ZUBE',
    name: 'Hauptbatterie Austausch-Set Qgw5 / 5.5d',
  },
  {
    productKey: 'RNG52D.BAT',
    customizedNumber: '35440',
    type: 'ZUBE',
    name: 'Hauptbatterie Austausch-Set Qgw5/5.5d 2D',
  },
  {
    productKey: 'RNG5KA2R2170 13000',
    customizedNumber: '35442',
    type: 'FE',
    name: 'kaloBLUE Gateway Qgateway V4',
  },
  {
    productKey: 'RNG5KA2R2180 1300M',
    customizedNumber: '35443',
    type: 'FE',
    name: 'KB GATEWAY 5 V3.0',
  },
  {
    productKey: 'RNG5KA2R3180 1300M',
    customizedNumber: '35444',
    type: 'FE',
    name: 'K GATEWAY 5 V3.0 2D',
  },
  {
    productKey: 'RNN5010M0004 04000',
    customizedNumber: '35450',
    type: 'FE',
    name: 'K NODE 5.5 V4.2',
  },
  {
    productKey: 'RNG5002T2180 1300O',
    customizedNumber: '35455',
    type: 'FE',
    name: 'K GATEWAY DIRECT 5.5 V3.0',
  },
  {
    productKey: 'RNG5002T2180 1300A',
    customizedNumber: '35455',
    type: 'FE',
    name: 'K GATEWAY DIRECT 5.5 V3.0',
  },
  {
    productKey: 'RNG5002T3180 1300O',
    customizedNumber: '35456',
    type: 'FE',
    name: 'K GATEWAY DIRECT 5.5 V3.0 2D',
  },
  {
    productKey: 'GW6101100300 00000',
    customizedNumber: '35457',
    type: 'FE',
    name: 'K GATEWAY DIRECT 6.0 V1.0 2D',
  },
  {
    productKey: 'RNNPH0010010',
    customizedNumber: '35490',
    type: 'ZUBE',
    name: 'USB-Programmieradapter für Q node 5/5.5',
  },
  {
    productKey: 'U12102-2003',
    customizedNumber: '36126',
    type: 'ZUBE',
    name: 'Plombe Qnode/QGW/QDMGW',
  },
  {
    productKey: 'HCAIK010 0S1',
    customizedNumber: '36128',
    type: 'ZUBE',
    name: 'Fernfühler-Satz komplett 1,5 m',
  },
  {
    productKey: 'HCAIK010 0S2',
    customizedNumber: '36129',
    type: 'ZUBE',
    name: 'Fernfühler-Satz komplett 2,5 m',
  },
  {
    productKey: 'HCAIK010 0S5',
    customizedNumber: '36139',
    type: 'ZUBE',
    name: 'Fernfühler-Satz komplett 5,0 m',
  },
  {
    productKey: 'HCAIK010 002',
    customizedNumber: '36152',
    type: 'ZUBE',
    name: 'FF-Satz Glieder-HK,  Teilung =< 40 mm',
  },
  {
    productKey: 'HCAIK010 003',
    customizedNumber: '36153',
    type: 'ZUBE',
    name: 'FF-Satz Guss-Radiator, Typ SR',
  },
  {
    productKey: 'HCAIK010 004',
    customizedNumber: '36154',
    type: 'ZUBE',
    name: 'FF-Satz Guss-Radiator, Typ RR, KR',
  },
  {
    productKey: 'HCAIK010 010',
    customizedNumber: '36155',
    type: 'ZUBE',
    name: 'FF-Satz  Alu-Glieder-HK',
  },
  {
    productKey: 'HCAIK010 012',
    customizedNumber: '36156',
    type: 'ZUBE',
    name: 'FF-Satz  Lamellen-Konvektoren',
  },
  {
    productKey: 'HCAIK010 013',
    customizedNumber: '36157',
    type: 'ZUBE',
    name: 'FF-Satz Fensterbank-Radiatoren',
  },
  {
    productKey: 'HCAIK010 014',
    customizedNumber: '36158',
    type: 'ZUBE',
    name: 'FF-Satz  Falt(en)-Radiatoren',
  },
  {
    productKey: 'HCAIP002 001',
    customizedNumber: '36159',
    type: 'ZUBE',
    name: 'Demontage-Tool Fernfühler Q caloric 5',
  },
  {
    productKey: 'HCA5KG1TB7B0 0A000',
    customizedNumber: '36609',
    type: 'HKVE',
    name: 'KB Heizkostenverteiler K 1.5 X G c-Mode',
  },
  {
    productKey: 'HCA5KG1NB7B0 0A000',
    customizedNumber: '36610',
    type: 'HKVE',
    name: 'kaloBLUE Heizkostenvert. K 1.5 X "G"',
  },
  {
    productKey: 'HCA5KA1NB7B0 0A000',
    customizedNumber: '36611',
    type: 'HKVE',
    name: 'kaloBLUE Heizkostenvert. K 1.5 X',
  },
  {
    productKey: 'HCA5KA1TB7B0 0A000',
    customizedNumber: '36613',
    type: 'HKVE',
    name: 'kaloBLUE HKV K1.5X AWC',
  },
  {
    productKey: 'HCA5KG1TB7B0 0A00L',
    customizedNumber: '36614',
    type: 'HKVE',
    name: 'KB Heizkostenverteiler K 1.5 X c-Mode G',
  },
  {
    productKey: 'HCA5K21NBA50 0A000',
    customizedNumber: '36615',
    type: 'HKVE',
    name: 'kaloBLUE Heizkostenvert. K 1.5 X FF 2,5m',
  },
  {
    productKey: 'HCA5K51NBA50 0A000',
    customizedNumber: '36618',
    type: 'HKVE',
    name: 'kaloBLUE Heizkostenvert. K 1.5 X FF 5,0m',
  },
  {
    productKey: 'HCA5KA1TB7B0 0A00V',
    customizedNumber: '36623',
    type: 'HKVE',
    name: 'kaloBLUE HKV K1.5X C5',
  },
  {
    productKey: 'HCA5K21TBA50 0A000',
    customizedNumber: '36625',
    type: 'HKVE',
    name: 'kaloBLUE HKV K1.5X FF 2,5m XC',
  },
  {
    productKey: 'HCA5K51TBA50 0A000',
    customizedNumber: '36628',
    type: 'HKVE',
    name: 'kaloBLUE HKV K1.5X FF 5,0m XC',
  },
  {
    productKey: 'FKK0240',
    customizedNumber: '36814',
    type: 'ZUBE',
    name: 'Wandhalterung Fernfühler K1.5/B1.5',
  },
  {
    productKey: 'HCAIP001 002',
    customizedNumber: '37051',
    type: 'ZUBE',
    name: 'QUNDIS Montage-Maßstab HKV',
  },
  {
    productKey: 'FOZ0003',
    customizedNumber: '39209',
    type: 'ZUBE',
    name: 'Fernfühler Beipacksatz klein K1.5/B1.5',
  },
  {
    productKey: 'FKA0032',
    customizedNumber: '39355',
    type: 'ZUBE',
    name: 'Pass-Stück mit FFK-Bohrung',
  },
  {
    productKey: '50533153H 4',
    customizedNumber: '40112',
    type: 'WMZ',
    name: 'WMWP-VMT qp 25 H/V DN65 200mm 100l/Imp',
  },
  {
    productKey: '50590987H 4',
    customizedNumber: '40113',
    type: 'WMZ',
    name: 'WMWP-VMT qp 200 H/V DN150 300mm 100l/Imp',
  },
  {
    productKey: 'WMBHZY00D00A 0AV00',
    customizedNumber: '40120',
    type: 'KWZ',
    name: 'KWZ Q3-40 200-DN50 WPT-H/V POV MAD',
  },
  {
    productKey: 'WMBHZY00H00A 0AV00',
    customizedNumber: '40121',
    type: 'KWZ',
    name: 'KWZ Q3-63 200-DN65 WPT-H/V POV MAD',
  },
  {
    productKey: 'WMBHZY00J00A 0AV00',
    customizedNumber: '40122',
    type: 'KWZ',
    name: 'KWZ Q3-100 225-DN80 WPT-H/V POV MAD',
  },
  {
    productKey: 'WMBHZY00N00A 0AV00',
    customizedNumber: '40123',
    type: 'KWZ',
    name: 'KWZ Q3-160 250-DN100 WPT-H/V POV MAD',
  },
  {
    productKey: 'WMM400000001 00V00',
    customizedNumber: '42580',
    type: 'KWZ',
    name: 'AP kalt Q3 2,5 ½" Baul.80 mm FV WE',
  },
  {
    productKey: 'WMM400002001 00V00',
    customizedNumber: '42617',
    type: 'KWZ',
    name: 'AP kalt Q3 4,0 ¾" 130 mm FV WE',
  },
  {
    productKey: 'WMM400100001 00V00',
    customizedNumber: '42720',
    type: 'WWZ',
    name: 'AP warm Q3 2,5 ½" Baul.80 mm FV WE',
  },
  {
    productKey: 'WMM400101001 00V00',
    customizedNumber: '42724',
    type: 'WWZ',
    name: 'WMM4-Q3 2,5 m³/h 110mm hot QUN',
  },
  {
    productKey: 'WMM400102001 00V00',
    customizedNumber: '42725',
    type: 'WWZ',
    name: 'AP warm Q3 4,0 ¾" 130 mm FV WE',
  },
  {
    productKey: 'WMMH00000001 Z6V00',
    customizedNumber: '42811',
    type: 'KWZ',
    name: 'K WATER 4 Q3-2,5 80-G¾ kalt FV MAD',
  },
  {
    productKey: 'WMMH00001001 Z6V00',
    customizedNumber: '42812',
    type: 'KWZ',
    name: 'K WATER 4 Q3-2,5 110-G¾ kalt FV MAD',
  },
  {
    productKey: 'WMMH00002001 Z6V00',
    customizedNumber: '42816',
    type: 'KWZ',
    name: 'K WATER 4 Q3-4,0 130-G1 kalt FV MAD',
  },
  {
    productKey: 'WMMH00003001 Z6V00',
    customizedNumber: '42817',
    type: 'KWZ',
    name: 'K WATER 4 Q3-2,5 130-G1 kalt FV MAD',
  },
  {
    productKey: 'WMMH00100001 Z6V00',
    customizedNumber: '42821',
    type: 'WWZ',
    name: 'K WATER 4 Q3-2,5 80-G¾ warm FV MAD',
  },
  {
    productKey: 'WMMH00101001 Z6V00',
    customizedNumber: '42822',
    type: 'WWZ',
    name: 'K WATER 4 Q3-2,5 110-G¾ warm FV MAD',
  },
  {
    productKey: 'WMMH00102001 Z6V00',
    customizedNumber: '42826',
    type: 'WWZ',
    name: 'K WATER 4 Q3-4,0 130-G1 warm FV MAD',
  },
  {
    productKey: 'BBV5520',
    customizedNumber: '43508',
    type: 'ZUBE',
    name: 'Ventilzähler Anschluss-Set',
  },
  {
    productKey: 'HMXIK003 002',
    customizedNumber: '43547',
    type: 'ZUBE',
    name: 'Adaptersatz G¾xG1 110 auf 130 mm',
  },
  {
    productKey: 'WFZ.UP3080',
    customizedNumber: '44230',
    type: 'ZUBE',
    name: 'Schiebestück UP 3080 WG',
  },
  {
    productKey: 'WFZ.UP3000',
    customizedNumber: '45230',
    type: 'ZUBE',
    name: 'Schiebestück UP 3000 AMS',
  },
  {
    productKey: 'WFZ.Z',
    customizedNumber: '45720',
    type: 'ZUBE',
    name: 'Anschlußbausatz Zapfhahnzähler',
  },
  {
    productKey: 'WMZ.MB6',
    customizedNumber: '46561',
    type: 'ZUBE',
    name: 'Montageblock UP MK DUO ¾" IG / B 1',
  },
  {
    productKey: 'WMZ.K5',
    customizedNumber: '46602',
    type: 'ZUBE',
    name: 'Montageschlüssel Div. MK-Zähler (Qundis)',
  },
  {
    productKey: 'WME.L18/H',
    customizedNumber: '46942',
    type: 'ZUBE',
    name: 'EAT ¾" AG/18 mm Löt KOAX',
  },
  {
    productKey: 'WME.G22',
    customizedNumber: '46946',
    type: 'ZUBE',
    name: 'EAT 1" AG, Baulänge 130 mm f. MK Qn 2,5',
  },
  {
    productKey: 'WME.L15/H',
    customizedNumber: '46947',
    type: 'ZUBE',
    name: 'EAT ½" IG KOAX',
  },
  {
    productKey: 'FKM0053',
    customizedNumber: '46951',
    type: 'ZUBE',
    name: 'Blindflansch für EAT Koax',
  },
  {
    productKey: 'WMDH0000H001 Z0V00',
    customizedNumber: '47117',
    type: 'KWZ',
    name: 'MN-R 30°C Q3 25 m³/h DN 50; 270 mm Vers.',
  },
  {
    productKey: 'WMDH0000F001 Z0V00',
    customizedNumber: '47118',
    type: 'KWZ',
    name: 'MT-X 30C° Q3 16m³/h DN40 300mm',
  },
  {
    productKey: 'WMDH0000A001 Z0V00',
    customizedNumber: '47717',
    type: 'KWZ',
    name: 'MT-X 30° Q3 2,5m³/h 165mm DN15',
  },
  {
    productKey: 'WMDH0000H001 Z0V00',
    customizedNumber: '47718',
    type: 'KWZ',
    name: 'WMDH-Q3 10m³/h 260mm DN25 MTK-HWX cold',
  },
  {
    productKey: 'WMDH0000K001 Z0V00',
    customizedNumber: '47719',
    type: 'KWZ',
    name: 'MT-SX 30°C 1.5 m³/h DN 20; Baul. 105 mm',
  },
  {
    productKey: 'WMDH0000P001 Z0V00',
    customizedNumber: '47720',
    type: 'KWZ',
    name: 'WMDH-Q3 16m³/h 150mm DN40 MTK-SWX cold',
  },
  {
    productKey: 'WMDH0010B001 Z0V00',
    customizedNumber: '47721',
    type: 'WWZ',
    name: 'WMDH-Q3 4,0m³/h 190mm DN20 MTW-HWX hot',
  },
  {
    productKey: 'WMDH0010F001 Z0V00',
    customizedNumber: '47722',
    type: 'WWZ',
    name: 'WMDH-Q3 16m³/h 300mm DN40 MTW-HWX hot',
  },
  {
    productKey: 'WMDH0010G001 Z0V00',
    customizedNumber: '47723',
    type: 'WWZ',
    name: 'WMDH-Q3 25m³/h 270mm DN50 MTW-HWX hot',
  },
  {
    productKey: 'WMDH0010K001 Z0V00',
    customizedNumber: '47724',
    type: 'WWZ',
    name: 'WMDH-Q3 2,5m³/h 105mm DN20 MTW-SWX hot',
  },
  {
    productKey: 'WMDH0010L001 Z0V00',
    customizedNumber: '47725',
    type: 'WWZ',
    name: 'WMDH-Q3 4,0m³/h 105mm DN20 MTW-SWX hot',
  },
  {
    productKey: 'WMDH0010N001 Z0V00',
    customizedNumber: '47726',
    type: 'WWZ',
    name: 'WMDH-Q3 10m³/h 150mm DN25 MTK-SWX hot',
  },
  {
    productKey: 'WMDH0000I001 Z0V00',
    customizedNumber: '47727',
    type: 'KWZ',
    name: 'WMDH-Q3 25m³/h 270mm FL50 MTK-HWX cold',
  },
  {
    productKey: 'WMDH0000E001 Z0V00',
    customizedNumber: '47730',
    type: 'KWZ',
    name: 'K WATER KWZ Q3-10 260-G1½ MT-H FV WEH',
  },
  {
    productKey: 'WFZ.BZES',
    customizedNumber: '48412',
    type: 'ZUBE',
    name: 'Ausgleichstück für BWZ ams ¾" x 44 mm',
  },
  {
    productKey: 'WMM40000A001 00V00',
    customizedNumber: '48613',
    type: 'KWZ',
    name: 'Meßkapsel Koaxial kalt MOE/MOC WEH',
  },
  {
    productKey: 'WMM40010A001 00V00',
    customizedNumber: '48621',
    type: 'WWZ',
    name: 'Meßkapsel Koaxial warm MOE/MOC  WEH',
  },
  {
    productKey: 'WMM40000C001 00V00',
    customizedNumber: '48708',
    type: 'KWZ',
    name: 'WMM4-Q3 2,5 m³/h MET cold QUN',
  },
  {
    productKey: 'WMM40010C001 00V00',
    customizedNumber: '48710',
    type: 'WWZ',
    name: 'WMM4-Q3 2,5 m³/h MET hot QUN',
  },
  {
    productKey: 'WMM40010C00100V00',
    customizedNumber: '48738',
    type: 'WWZ',
    name: 'Meßkapsel Koaxial MET warm WEH',
  },
  {
    productKey: 'FKK0139',
    customizedNumber: '63723',
    type: 'ZUBE',
    name: 'Verplombungsset Plombenringe',
  },
  {
    productKey: 'WMXI.KMB1 001',
    customizedNumber: '63916',
    type: 'ZUBE',
    name: 'Fertigmontageset UP-Ventil kurz',
  },
  {
    productKey: 'WMXI.KMB1 002',
    customizedNumber: '63922',
    type: 'ZUBE',
    name: 'Fertigmontageset UP-Ventil lang',
  },
  {
    productKey: 'WFZ.R80',
    customizedNumber: '64141',
    type: 'ZUBE',
    name: 'Zählerersatzstück ¾" 80 mm DN 15',
  },
  {
    productKey: 'F10102-2003/3',
    customizedNumber: '64417',
    type: 'ZUBE',
    name: 'Selflock-Plombe für WZ',
  },
  {
    productKey: 'SDTHKA5001200000 0',
    customizedNumber: '73000',
    type: 'RMG',
    name: 'Hörgeschädigtenpaket kaloPRIMUS X',
  },
  {
    productKey: 'SDTIKHKK 001',
    customizedNumber: '73036',
    type: 'ZUBE',
    name: 'Klebepad  für Genius',
  },
  {
    productKey: 'FSS0030',
    customizedNumber: '73057',
    type: 'ZUBE',
    name: 'Klebeplombe-QUNDIS-Q-rot-blau-rund-7,5',
  },
  {
    productKey: 'SDTIKATC 020',
    customizedNumber: '73058',
    type: 'ZUBE',
    name: 'Q SMOKE 5.5R KLEBEPAD Atral',
  },
  {
    productKey: 'SDTIKHKK 100',
    customizedNumber: '73059',
    type: 'ZUBE',
    name: 'Klebepadset VE 100',
  },
  {
    productKey: 'SDTIKHKP 032',
    customizedNumber: '73060',
    type: 'ZUBE',
    name: 'Plombenset VE 32',
  },
  {
    productKey: 'SDT500473000 00000',
    customizedNumber: '73070',
    type: 'RMG',
    name: 'KB SMOKE 5.5 R C-Mode',
  },
  {
    productKey: 'SDTIAHTA 001',
    customizedNumber: '73087',
    type: 'ZUBE',
    name: 'lisa alarmo',
  },
  {
    productKey: 'SDTHKA700000 00000',
    customizedNumber: '73088',
    type: 'ZUBE',
    name: 'lisa Funk-Blitzlampe',
  },
  {
    productKey: 'SDTIAHTV 001',
    customizedNumber: '73089',
    type: 'ZUBE',
    name: 'lisa Vibrationskissen',
  },
  {
    productKey: 'SDT5ZZ3V0000 00000',
    customizedNumber: '73092',
    type: 'RMG',
    name: 'Rauchwarnmelder kaloGENIUS Plus X FV',
  },
  {
    productKey: 'SDTIKHFM 001',
    customizedNumber: '73093',
    type: 'FMR',
    name: 'Funkmodul kaloGENIUS Basis X',
  },
  {
    productKey: 'SDT500473000 000A0',
    customizedNumber: '73099',
    type: 'RMG',
    name: 'KB SMOKE 5.5 R C-Mode - reflash',
  },
  {
    productKey: 'WMMHZY00U001 Z3V00',
    customizedNumber: '81009',
    type: 'KWZ',
    name: 'AP kalt Q3 2,5 AG ¾" Baul. 60mm FV',
  },
  {
    productKey: 'MHM500A20000 02000',
    customizedNumber: '83097',
    type: 'MBMO',
    name: 'M-Bus-Modul Kaloheat',
  },
  {
    productKey: 'R210A10K0 M 0100',
    customizedNumber: '84239',
    type: 'WMZ',
    name: 'Unical W: Rechenwerk Control R21 250 l',
  },
  {
    productKey: 'R21-1A10K0 M 0100',
    customizedNumber: '84242',
    type: 'WMZ',
    name: 'Unical W: RW Control R21 250 l PT500',
  },
  {
    productKey: 'R20C03000 M 0100',
    customizedNumber: '84407',
    type: 'WMZ',
    name: 'R20 Rechenwerk 0,1l Pt1000',
  },
  {
    productKey: 'R20C07000 M 0100',
    customizedNumber: '84408',
    type: 'WMZ',
    name: 'R20 Rechenwerk 0,1l Pt1000 VL',
  },
  {
    productKey: 'R20C33000 M 0100',
    customizedNumber: '84409',
    type: 'WMZ',
    name: 'R20 Rechenwerk 1,0l Pt1000',
  },
  {
    productKey: 'R20C62000 M 0100',
    customizedNumber: '84410',
    type: 'WMZ',
    name: 'R20 Rechenwerk 10,0l Pt1000',
  },
  {
    productKey: 'R20C66000 M 0100',
    customizedNumber: '84411',
    type: 'WMZ',
    name: 'R20 Rechenwerk 10,0l Pt1000 VL',
  },
  {
    productKey: 'R20C92000 M 0100',
    customizedNumber: '84412',
    type: 'WMZ',
    name: 'R20 Rechenwerk 100,0l Pt1000',
  },
  {
    productKey: 'R20C96000 M 0100',
    customizedNumber: '84413',
    type: 'WMZ',
    name: 'R20 Rechenwerk 100,0l Pt1000 VL',
  },
  {
    productKey: 'R21C03000 M 0100',
    customizedNumber: '84414',
    type: 'WMZ',
    name: 'R21 Kombi-Rechenwerk 0,1l Pt1000',
  },
  {
    productKey: 'R21C07000 M 0100',
    customizedNumber: '84415',
    type: 'WMZ',
    name: 'R21 Kombi-Rechenwerk 0,1l Pt1000 VL',
  },
  {
    productKey: 'R21C92000 M 0100',
    customizedNumber: '84416',
    type: 'WMZ',
    name: 'R21 Kombi-Rechenwerk 100,0l Pt1000',
  },
  {
    productKey: 'R20C37000 M 0100',
    customizedNumber: '84417',
    type: 'WMZ',
    name: 'R20 Rechenwerk 1,0l Pt1000 VL',
  },
  {
    productKey: 'R21C33000 M 0100',
    customizedNumber: '84418',
    type: 'WMZ',
    name: 'R21 Kombi-Rechenwerk 1,0l Pt1000',
  },
  {
    productKey: 'R21C37000 M 0100',
    customizedNumber: '84423',
    type: 'WMZ',
    name: 'R21 Kombi-Rechenwerk 1,0l Pt1000 VL',
  },
  {
    productKey: 'R21C66000 M 0100',
    customizedNumber: '84424',
    type: 'WMZ',
    name: 'R21 Kombi-Rechenwerk 10,0l Pt1000 VL',
  },
  {
    productKey: 'R20B230K0 M 0100',
    customizedNumber: '84439',
    type: 'WMZ',
    name: 'Unical W: RW R20  0,5 l Pt 500 0,6-10,0',
  },
  {
    productKey: 'R20B220K0 M 0100',
    customizedNumber: '84440',
    type: 'WMZ',
    name: 'Unical W: RW R20 0,5 L PT500 QN 0,6 - 60',
  },
  {
    productKey: 'R21B270K0 M 0100',
    customizedNumber: '84442',
    type: 'WMZ',
    name: 'Unical R21 0.5 l P500 Qn 0,6-10,0 Vorl.',
  },
  {
    productKey: 'R21B260K0 M 0100',
    customizedNumber: '84443',
    type: 'WMZ',
    name: 'KaloUltra R21 0.5 l Qn 0,6-60,0 Vorl',
  },
  {
    productKey: 'R21B230K0 M 0100',
    customizedNumber: '84445',
    type: 'WMZ',
    name: 'KaloUltra R21 0.5 l Qn 0,6-60,0 Kombi',
  },
  {
    productKey: 'R20B260K0 M 0100',
    customizedNumber: '84446',
    type: 'WMZ',
    name: 'Unical W: RW R20 0,5  PT500  0,6 - 60 VL',
  },
  {
    productKey: 'HMR500011140 00000',
    customizedNumber: '84511',
    type: 'WMZ',
    name: 'KALOHEAT S Qp 1,5 ¾" AG 110mm RW HA',
  },
  {
    productKey: 'HMR500012040 00000',
    customizedNumber: '84512',
    type: 'WMZ',
    name: 'KALOHEAT Qp 2,5 1" AG 130mm RW HA',
  },
  {
    productKey: 'HMR500012140 00000',
    customizedNumber: '84513',
    type: 'WMZ',
    name: 'kaloHeat S Qn 2,5 1" AG 130 mm RW a',
  },
  {
    productKey: 'HMR500012440 00000',
    customizedNumber: '84515',
    type: 'WMZ',
    name: 'kaloHeat Qn2,5 1" AG130mm kompakt dir.3m',
  },
  {
    productKey: 'HMR500010140 00000',
    customizedNumber: '84516',
    type: 'WMZ',
    name: 'kaloHeat S Qn 0,6 ¾" AG 110 mm RW a',
  },
  {
    productKey: 'HMR50001J040 00000',
    customizedNumber: '84520',
    type: 'WMZ',
    name: 'kaloHeat Qn 0,6 ¾" AG 110 mm dir. Vorl',
  },
  {
    productKey: 'HMR500010040 00000',
    customizedNumber: '84521',
    type: 'WMZ',
    name: 'kaloHeat Qn 0,6 ¾" AG 110 mm dir.',
  },
  {
    productKey: 'HMR50001K040 00000',
    customizedNumber: '84522',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" AG 110 mm dir. Vorl',
  },
  {
    productKey: 'HMR500011040 00000',
    customizedNumber: '84523',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" 110 mm dir. HA RW a',
  },
  {
    productKey: 'HMR500010440 00000',
    customizedNumber: '84530',
    type: 'WMZ',
    name: 'kaloHeat Qn 0,6 ¾" AG 110 mm dir. 3m',
  },
  {
    productKey: 'HMR500011240 00000',
    customizedNumber: '84532',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" AG 110 mm; 6mm',
  },
  {
    productKey: 'HMR500012240 00000',
    customizedNumber: '84533',
    type: 'WMZ',
    name: 'kaloHeat Qn 2,5 1" AG 130 mm; 6mm',
  },
  {
    productKey: 'HMR50001K240 00000',
    customizedNumber: '84534',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" AG 110 mm; 6mm VL',
  },
  {
    productKey: 'HMR500010240 00000',
    customizedNumber: '84535',
    type: 'WMZ',
    name: 'kaloHeat Qn 0,6 ¾" AG 110 mm 6mm RW a.',
  },
  {
    productKey: 'HMR50001L040 00000',
    customizedNumber: '84536',
    type: 'WMZ',
    name: 'kaloHeat Qn 2,5 1" AG 130; 5mm Vorl',
  },
  {
    productKey: 'HMR50001K140 00000',
    customizedNumber: '84539',
    type: 'WMZ',
    name: 'kaloHeat S Qn 1,5 1" AG 110 Vorl',
  },
  {
    productKey: 'HMC5KA011000 01000',
    customizedNumber: '84540',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5 ¾" 110 mm dir. HA RW a',
  },
  {
    productKey: 'HMC500012040 00000',
    customizedNumber: '84542',
    type: 'WMZ',
    name: 'Qn 2,5 1" AG 130 mm dir. HA s.84512',
  },
  {
    productKey: 'HMR500011440 00000',
    customizedNumber: '84543',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5  ¾" AG 110 mm dir. 3m',
  },
  {
    productKey: 'HMR50001L140 00000',
    customizedNumber: '84545',
    type: 'WMZ',
    name: 'kaloHeat S Qn 2,5 1" AG 130 Vorl',
  },
  {
    productKey: 'HMR500016140 00000',
    customizedNumber: '84548',
    type: 'WMZ',
    name: 'HMR5-OPTO 2,5xIST 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR50001Q540 00000',
    customizedNumber: '84549',
    type: 'WMZ',
    name: 'WMZ-FR 1,5-A1 5,2x3,0 VL WA FV QUN',
  },
  {
    productKey: 'HMR500018040 00000',
    customizedNumber: '84550',
    type: 'WMZ',
    name: 'HMR5-OPTO 1,5xAMS 5,0x1,5m B6 QU',
  },
  {
    productKey: 'HMR500018140 00000',
    customizedNumber: '84551',
    type: 'WMZ',
    name: 'kaloHeat MK-S Qn 1,5m Fühler 5,2 mm',
  },
  {
    productKey: 'HMR50001N140 00000',
    customizedNumber: '84552',
    type: 'WMZ',
    name: 'kaloHeat Koax  1,5/1,5m Fühler 5,2 VL',
  },
  {
    productKey: 'HMR50001O040 00000',
    customizedNumber: '84553',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qp2,5/1,5m 5,2 VL',
  },
  {
    productKey: 'HMR50001O440 00000',
    customizedNumber: '84554',
    type: 'ZUBE',
    name: 'kaloHeat Koax  Qp2,5/1,5m 5,2 VL 3m',
  },
  {
    productKey: 'HMR5000C1040 00000',
    customizedNumber: '84555',
    type: 'WMZ',
    name: 'kaloHeat Qn 1,5  110 mm dir. int.M-Bus',
  },
  {
    productKey: 'HMR500111140 00000',
    customizedNumber: '84556',
    type: 'WMZ',
    name: 'KALOHEAT S Qp 1,5 ¾" AG 110mm RW HA',
  },
  {
    productKey: 'HMR500112140 00000',
    customizedNumber: '84557',
    type: 'WMZ',
    name: 'HMR5-OPTO 2,5x130 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR50011K140 00000',
    customizedNumber: '84558',
    type: 'WMZ',
    name: 'kaloHeat S Qn 1,5 ¾" AG 110mm W/K',
  },
  {
    productKey: 'HMR50011L140 00000',
    customizedNumber: '84559',
    type: 'WMZ',
    name: 'kaloHeat S Qn 2,5 1" AG 130mm W/K dir.',
  },
  {
    productKey: 'HMR500A11090 60000',
    customizedNumber: '84560',
    type: 'WMZ',
    name: 'HMR5-OPTO-US 1,5x110 5,0x1,5m B6 QUN',
  },
  {
    productKey: 'HMR500A11190 00020',
    customizedNumber: '84561',
    type: 'WMZ',
    name: 'HMR5-OPTO-US 1,5x110 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR500A11490 00000',
    customizedNumber: '84562',
    type: 'WMZ',
    name: 'kaloHeat US Qn 1,5 ¾" 110 mm 5,0 3m',
  },
  {
    productKey: 'HMR500A12190 00020',
    customizedNumber: '84563',
    type: 'WMZ',
    name: 'HMR5-OPTO-US 2,5x130 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR500A12590 00000',
    customizedNumber: '84564',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,2 3,0m',
  },
  {
    productKey: 'HMR500A1K190 00000',
    customizedNumber: '84565',
    type: 'WMZ',
    name: 'kaloHeat US Qn 1,5 ¾" 110 mm 5,2 mm VL',
  },
  {
    productKey: 'HMR500018540 00000',
    customizedNumber: '84566',
    type: 'WMZ',
    name: 'WMZ-FR 1,5-A1 5,2x3,0 RL W FV QUN',
  },
  {
    productKey: 'HMR500018940 00000',
    customizedNumber: '84567',
    type: 'WMZ',
    name: 'WMZ-FR 1,5-A1 6,0x3,0 RL W FV QUN',
  },
  {
    productKey: 'HMR50001Q940 00000',
    customizedNumber: '84568',
    type: 'WMZ',
    name: 'WMZ-FR 1,5-A1 6,0x3,0 VL W FV QUN',
  },
  {
    productKey: 'HMR50011J140 00000',
    customizedNumber: '84571',
    type: 'WMZ',
    name: 'kaloHeat Qn 0,6 ¾" AG 110mm W/K Vorl.',
  },
  {
    productKey: 'HMR500112040 00000',
    customizedNumber: '84572',
    type: 'WMZ',
    name: 'kaloHeat Qn 2,5 1" AG 130mm W/K dir.',
  },
  {
    productKey: 'HMR500112100 00000',
    customizedNumber: '84573',
    type: 'WMZ',
    name: 'kaloHeat Qn 2,5 1" AG 130mm W/K',
  },
  {
    productKey: 'HMR50001B140 00000',
    customizedNumber: '84575',
    type: 'WMZ',
    name: 'HMR5-OPTO 1,5xTE1 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR50001C140 00000',
    customizedNumber: '84576',
    type: 'WMZ',
    name: 'HMR5-OPTO 2,5xTE1 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR50001T140 00000',
    customizedNumber: '84577',
    type: 'WMZ',
    name: 'HMR5-OPTO 1,5xTE1 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR50001U140 00000',
    customizedNumber: '84578',
    type: 'WMZ',
    name: 'HMR5-OPTO 2,5xTE1 5,2x1,5m B6 QUN',
  },
  {
    productKey: 'HMR500A12090 00000',
    customizedNumber: '84582',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,0 mm',
  },
  {
    productKey: 'HMR500A12190 00000',
    customizedNumber: '84583',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,2 mm',
  },
  {
    productKey: 'HMR500A1K090 00000',
    customizedNumber: '84584',
    type: 'WMZ',
    name: 'kaloHeat US Qn 1,5 ¾" AG 110 mm 5,0 VL',
  },
  {
    productKey: 'HMR500A1L090 00000',
    customizedNumber: '84586',
    type: 'WMZ',
    name: 'kaloHeat US Qn 2,5 1" AG 130 mm 5,0 VL',
  },
  {
    productKey: 'WME5000N0011 00V00',
    customizedNumber: '84611',
    type: 'KWZ',
    name: "kaloBLUE AP kalt Q3 2,5 ½'' 80 mm",
  },
  {
    productKey: 'WME5KG0T0011 00V00',
    customizedNumber: '84613',
    type: 'KWZ',
    name: 'kaloBLUE AP kalt Q3 2,5 ½\'\' 80 mm "G"',
  },
  {
    productKey: 'WME5KG0T0011 00V0V',
    customizedNumber: '84615',
    type: 'KWZ',
    name: 'kaloBLUE AP kalt Q3 2,5 ½\'\' 80 mm "G"',
  },
  {
    productKey: 'WME5010N2011 00V00',
    customizedNumber: '84616',
    type: 'KWZ',
    name: "kaloBLUE AP kalt Q3 4,0 ¾'' 130 mm",
  },
  {
    productKey: 'WME5KG0T1011 00V0V',
    customizedNumber: '84618',
    type: 'KWZ',
    name: 'kaloBLUE AP KALT Q3 2,5 ½\'\' 110 mm "G"',
  },
  {
    productKey: 'WME5KG0T2011 00V0V',
    customizedNumber: '84619',
    type: 'KWZ',
    name: 'kaloBLUE AP kalt Q3 4,0 ¾\'\' 130 mm "G"',
  },
  {
    productKey: 'WME5KG1T0011 00V00',
    customizedNumber: '84623',
    type: 'WWZ',
    name: 'kaloBLUE AP warm Q3 2,5 ½\'\' 80 mm "G"',
  },
  {
    productKey: 'WME5KG1T1011 00V00',
    customizedNumber: '84624',
    type: 'WWZ',
    name: 'kaloBLUE AP warm Q3 2,5 ½\'\' 110 mm "G"',
  },
  {
    productKey: 'WME5011N2011 00V00',
    customizedNumber: '84626',
    type: 'WWZ',
    name: "kaloBLUE AP warm Q3 4,0 ¾'' 130 mm",
  },
  {
    productKey: 'WME5KG1T2011 00V00',
    customizedNumber: '84627',
    type: 'WWZ',
    name: 'kaloBLUE AP warm Q3 4,0 ¾\'\' 130 mm "G"',
  },
  {
    productKey: 'RHM5KAAN0000 Z010K',
    customizedNumber: '84630',
    type: 'HIM',
    name: 'kaloBLUE Funkmodul Wärmezähler XWK',
  },
  {
    productKey: 'RHM5KGAN0000 Z010K',
    customizedNumber: '84631',
    type: 'HIM',
    name: 'kaloBLUE Funkmodul Wärmezähler XWK G',
  },
  {
    productKey: 'RWM5KA0T0000 0000K',
    customizedNumber: '84632',
    type: 'HIM',
    name: 'kaloBLUE Funkmodul Wärmezähler "G"',
  },
  {
    productKey: 'BBV3018',
    customizedNumber: '84633',
    type: 'ZUBE',
    name: 'Schrauben XWK mit 10 Schrauben /Plomben',
  },
  {
    productKey: 'RHM501AT0000 Z0000',
    customizedNumber: '84634',
    type: 'HIM',
    name: 'KB MODULE HEAT 5.5 AWC',
  },
  {
    productKey: 'RHM5KGAT0000 Z010L',
    customizedNumber: '84635',
    type: 'HIM',
    name: 'kaloBLUE Funkmodul Wärmezähler "G"',
  },
  {
    productKey: 'WME5KG1T0011 00V0V',
    customizedNumber: '84637',
    type: 'WWZ',
    name: 'kaloBLUE AP warm Q3 2,5 ½\'\' 80 mm "G"',
  },
  {
    productKey: 'WME5KG1T1011 00V0V',
    customizedNumber: '84638',
    type: 'WWZ',
    name: 'kaloBLUE AP warm Q3 2,5 ½\'\' 110 mm "G"',
  },
  {
    productKey: 'WME5KG1T2011 00V0V',
    customizedNumber: '84639',
    type: 'WWZ',
    name: 'kaloBLUE AP warm Q3 4,0 ¾\'\' 130 mm "G"',
  },
  {
    productKey: 'WME5000N4111 00V00',
    customizedNumber: '84701',
    type: 'KWZ',
    name: "kaloBLUE Messkapsel kalt IST 2'' koax",
  },
  {
    productKey: 'WME5010N6011 00V00',
    customizedNumber: '84703',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt A34',
  },
  {
    productKey: 'WME5010NA111 00V00',
    customizedNumber: '84705',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MOC/MOE',
  },
  {
    productKey: 'WME5010NV011 00V00',
    customizedNumber: '84711',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MUK',
  },
  {
    productKey: 'WME5011NV011 00V00',
    customizedNumber: '84712',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MUK',
  },
  {
    productKey: 'WME5010NT011 00V00',
    customizedNumber: '84713',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt DM1',
  },
  {
    productKey: 'WME5011NT011 00V00',
    customizedNumber: '84714',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm DM1',
  },
  {
    productKey: 'WME5010NX011 00V00',
    customizedNumber: '84715',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt WGU',
  },
  {
    productKey: 'WME5011NX011 00V00',
    customizedNumber: '84716',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm WGU',
  },
  {
    productKey: 'WME5010NW011 00V00',
    customizedNumber: '84717',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt WE1',
  },
  {
    productKey: 'WME5011NW011 00V00',
    customizedNumber: '84718',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm WE1',
  },
  {
    productKey: 'WME5010NE011 00V00',
    customizedNumber: '84719',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt HT2',
  },
  {
    productKey: 'WME5011NE011 00V00',
    customizedNumber: '84720',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm HT2',
  },
  {
    productKey: 'WME5010NJ011 00V00',
    customizedNumber: '84721',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MB3',
  },
  {
    productKey: 'WME5011NJ011 00V00',
    customizedNumber: '84722',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MB3',
  },
  {
    productKey: 'WME5010N8111 00V00',
    customizedNumber: '84723',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt TE1',
  },
  {
    productKey: 'WME5011N8111 00V00',
    customizedNumber: '84724',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm TE1',
  },
  {
    productKey: 'WME5KG0TC111 00V00',
    customizedNumber: '84725',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MET "G"',
  },
  {
    productKey: 'WME5KG0TA111 00V00',
    customizedNumber: '84727',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MOC/MOE "G"',
  },
  {
    productKey: 'WME5KG0TV011 00V00',
    customizedNumber: '84729',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MUK "G"',
  },
  {
    productKey: 'WME5KG0TT011 00V00',
    customizedNumber: '84730',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt DM1 "G"',
  },
  {
    productKey: 'WME5KG0TX011 00V00',
    customizedNumber: '84731',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt WGU "G"',
  },
  {
    productKey: 'WME5KG0TW011 00V00',
    customizedNumber: '84732',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt WE1 "G"',
  },
  {
    productKey: 'WME5KG0TE011 00V00',
    customizedNumber: '84734',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt HT2  "G"',
  },
  {
    productKey: 'WME5KG0T6011 00V00',
    customizedNumber: '84735',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt A34 "G"',
  },
  {
    productKey: 'WME5KG0TJ011 00V00',
    customizedNumber: '84736',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MB3  "G"',
  },
  {
    productKey: 'WME5KG1TC111 00V00',
    customizedNumber: '84737',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MET "G"',
  },
  {
    productKey: 'WME5KG1T4111 00V00',
    customizedNumber: '84738',
    type: 'WWZ',
    name: 'kaloBLUE MK-Koax warm IST 2\'\' "G"',
  },
  {
    productKey: 'WME5KG1TA111 00V00',
    customizedNumber: '84739',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MOC/MOE "G"',
  },
  {
    productKey: 'WME5KG1T8111 00V00',
    customizedNumber: '84740',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm TE1 "G"',
  },
  {
    productKey: 'WME5KG1TV011 00V00',
    customizedNumber: '84741',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MUK "G"',
  },
  {
    productKey: 'WME5KG1TT011 00V00',
    customizedNumber: '84742',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm DM1 "G"',
  },
  {
    productKey: 'WME5KG1TX011 00V00',
    customizedNumber: '84743',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm WGU "G"',
  },
  {
    productKey: 'WME5KG1TW011 00V00',
    customizedNumber: '84744',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm WE1 "G"',
  },
  {
    productKey: 'WME5KG1TE011 00V00',
    customizedNumber: '84745',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm HT2 "G"',
  },
  {
    productKey: 'WME5KG1T6011 00V00',
    customizedNumber: '84746',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm A34 "G"',
  },
  {
    productKey: 'WME5KG1TJ011 00V00',
    customizedNumber: '84747',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MB3 "G"',
  },
  {
    productKey: 'WFZ.B6-1',
    customizedNumber: '84749',
    type: 'ZUBE',
    name: 'KaloBLUE Rosette/ Tubus verchromt',
  },
  {
    productKey: 'WFZ.B6-2',
    customizedNumber: '84750',
    type: 'ZUBE',
    name: 'KaloBLUE Ros.-Tub. Funk, silber lackiert',
  },
  {
    productKey: 'WMXI.KBL1 005',
    customizedNumber: '84781',
    type: 'ZUBE',
    name: 'Blinddeckel Tubus - weiß QUN',
  },
  {
    productKey: 'WMXI.KCR1 005',
    customizedNumber: '84782',
    type: 'ZUBE',
    name: 'Blinddeckel Tubus - Chromoptik QUN',
  },
  {
    productKey: 'WME5KG0TC111 00V0V',
    customizedNumber: '84783',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MET "G"',
  },
  {
    productKey: 'WME5KG0T4111 00V0V',
    customizedNumber: '84784',
    type: 'KWZ',
    name: 'kaloBLUE MK-Koax IST 2\'\' kalt "G"',
  },
  {
    productKey: 'WME5KG0TA111 00V0V',
    customizedNumber: '84785',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MOC/MOE "G"',
  },
  {
    productKey: 'WME5KG0T8111 00V0V',
    customizedNumber: '84786',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt TE1 "G"',
  },
  {
    productKey: 'WME5KA0TT011 00V00',
    customizedNumber: '84788',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt DM1 "G"',
  },
  {
    productKey: 'WME5KA0TX011 00V00',
    customizedNumber: '84789',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt WGU "G"',
  },
  {
    productKey: 'WME5KA0TW011 00V00',
    customizedNumber: '84790',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt WE1 "G"',
  },
  {
    productKey: 'WME5KG0TE011 00V0V',
    customizedNumber: '84791',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt HT2  "G"',
  },
  {
    productKey: 'WME5KG0T6011 00V0V',
    customizedNumber: '84792',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt A34 "G"',
  },
  {
    productKey: 'WME5KA0TJ011 00V00',
    customizedNumber: '84793',
    type: 'KWZ',
    name: 'kaloBLUE Messkapsel kalt MB3  "G"',
  },
  {
    productKey: 'WME5KG1TC111 00V0V',
    customizedNumber: '84794',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MET "G"',
  },
  {
    productKey: 'WME5KG1T4111 00V0V',
    customizedNumber: '84795',
    type: 'WWZ',
    name: 'kaloBLUE MK-Koax warm IST 2\'\' "G"',
  },
  {
    productKey: 'WME5KG1TA111 00V0V',
    customizedNumber: '84796',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MOC/MOE "G"',
  },
  {
    productKey: 'WME5KG1T8111 00V0V',
    customizedNumber: '84797',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm TE1 "G"',
  },
  {
    productKey: 'WME5KA1TV011 00V00',
    customizedNumber: '84798',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MUK "G"',
  },
  {
    productKey: 'WME5KA1TT011 00V00',
    customizedNumber: '84799',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm DM1 "G"',
  },
  {
    productKey: 'WME5KG1TX011 00V0V',
    customizedNumber: '84800',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm WGU "G"',
  },
  {
    productKey: 'WME5KA1TW011 00V00',
    customizedNumber: '84801',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm WE1 "G"',
  },
  {
    productKey: 'WME5KG1TE011 00V0V',
    customizedNumber: '84802',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm HT2 "G"',
  },
  {
    productKey: 'WME5KG1T6011 00V0V',
    customizedNumber: '84803',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm A34 "G"',
  },
  {
    productKey: 'WME5KA1TJ011 00V00',
    customizedNumber: '84804',
    type: 'WWZ',
    name: 'kaloBLUE Messkapsel warm MB3 "G"',
  },
  {
    productKey: 'WTZ.RM',
    customizedNumber: '84826',
    type: 'ZUBE',
    name: 'Radiomodul',
  },
  {
    productKey: 'HMR500015400 01000',
    customizedNumber: '85522',
    type: 'WMZ',
    name: 'kaloHeat Koax  Qn 1,5 / 3,0m Fühler',
  },
  {
    productKey: 'WME5010T0011 00V00',
    customizedNumber: '85611',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 80-G¾ kalt AWC',
  },
  {
    productKey: 'WME5010T1011 00V00',
    customizedNumber: '85612',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 110-G¾ kalt AWC',
  },
  {
    productKey: 'WME5010T2011 00V00',
    customizedNumber: '85616',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-4,0 130-G1 kalt AWC',
  },
  {
    productKey: 'WME5011T0011 00V00',
    customizedNumber: '85621',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 80-G¾ warm AWC',
  },
  {
    productKey: 'WME5011T1011 00V00',
    customizedNumber: '85622',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 110-G¾ warm AWC',
  },
  {
    productKey: 'WME5011T2011 00V00',
    customizedNumber: '85626',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-4,0 130-G1 warm AWC',
  },
  {
    productKey: 'WME5000T4111 00V00',
    customizedNumber: '85701',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 IST kalt AWC',
  },
  {
    productKey: 'WME5001T4111 00V00',
    customizedNumber: '85702',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 IST warm AWC',
  },
  {
    productKey: 'WME5000T6111 00V00',
    customizedNumber: '85703',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 A34 kalt AWC',
  },
  {
    productKey: 'WME5001T6111 00V00',
    customizedNumber: '85704',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 A34 warm AWC',
  },
  {
    productKey: 'WME5000TA111 00V00',
    customizedNumber: '85705',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 MOC kalt AWC',
  },
  {
    productKey: 'WME5001TA111 00V00',
    customizedNumber: '85706',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 MOC warm AWC',
  },
  {
    productKey: 'WME5010TC111 00V00',
    customizedNumber: '85707',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 MET kalt AWC',
  },
  {
    productKey: 'WME5011TC111 00V00',
    customizedNumber: '85708',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 MET warm AWC',
  },
  {
    productKey: 'WME5010T6011 00V00',
    customizedNumber: '85709',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 A34 kalt XC',
  },
  {
    productKey: 'WME5011T6011 00V00',
    customizedNumber: '85710',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 A34 warm XC',
  },
  {
    productKey: 'WME5010TV011 00V00',
    customizedNumber: '85711',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 MUK kalt AWC',
  },
  {
    productKey: 'WME5011TV011 00V00',
    customizedNumber: '85712',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 MUK warm AWC',
  },
  {
    productKey: 'WME5010TT011 00V00',
    customizedNumber: '85713',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 DM1 kalt AWC',
  },
  {
    productKey: 'WME5011TT011 00V00',
    customizedNumber: '85714',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 DM1 warm AWC',
  },
  {
    productKey: 'WME5010TX011 00V00',
    customizedNumber: '85715',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 WGU kalt AWC',
  },
  {
    productKey: 'WME5011TX011 00V00',
    customizedNumber: '85716',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 WGU warm AWC',
  },
  {
    productKey: 'WME5010TW011 00V00',
    customizedNumber: '85717',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 WE1 kalt AWC',
  },
  {
    productKey: 'WME5011TW011 00V00',
    customizedNumber: '85718',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 WE1 warm AWC',
  },
  {
    productKey: 'WME5010TE011 00V00',
    customizedNumber: '85719',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 HT2 kalt AWC',
  },
  {
    productKey: 'WME5011TE011 00V00',
    customizedNumber: '85720',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 HT2 warm AWC',
  },
  {
    productKey: 'WME5010TJ011 00V00',
    customizedNumber: '85721',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 MB3 kalt AWC',
  },
  {
    productKey: 'WME5011TJ011 00V00',
    customizedNumber: '85722',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 MB3 warm AWC',
  },
  {
    productKey: 'WME5010T8111 00V00',
    customizedNumber: '85723',
    type: 'KWZ',
    name: 'KB WATER 5.5 Q3-2,5 TE1 kalt AWC',
  },
  {
    productKey: 'WME5011T8111 00V00',
    customizedNumber: '85724',
    type: 'WWZ',
    name: 'KB WATER 5.5 Q3-2,5 TE1 warm AWC',
  },
  {
    productKey: 'WME5010T4111 00V0V',
    customizedNumber: '85801',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 IST kalt XC5',
  },
  {
    productKey: 'WME5011T4111 00V0V',
    customizedNumber: '85802',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 IST warm XC5',
  },
  {
    productKey: 'WME5010T6111 00V0V',
    customizedNumber: '85803',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 A34 kalt XC5',
  },
  {
    productKey: 'WME5011T6111 00V0V',
    customizedNumber: '85804',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 A34 warm XC5',
  },
  {
    productKey: 'WME5010TA111 00V0V',
    customizedNumber: '85805',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 MOC kalt XC5',
  },
  {
    productKey: 'WME5011TA111 00V0V',
    customizedNumber: '85806',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 MOC warm XC5',
  },
  {
    productKey: 'WME5010TC111 00V0V',
    customizedNumber: '85807',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 MET kalt XC5',
  },
  {
    productKey: 'WME5011TC111 00V0V',
    customizedNumber: '85808',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 MET warm XC5',
  },
  {
    productKey: 'WME5010TV011 00V0V',
    customizedNumber: '85811',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 MUK kalt XC5',
  },
  {
    productKey: 'WME5011TV011 00V0V',
    customizedNumber: '85812',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 MUK warm XC5',
  },
  {
    productKey: 'WME5010TT011 00V0V',
    customizedNumber: '85813',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 DM1 kalt XC5',
  },
  {
    productKey: 'WME5011TT011 00V0V',
    customizedNumber: '85814',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 DM1 warm XC5',
  },
  {
    productKey: 'WME5010TX011 00V0V',
    customizedNumber: '85815',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 WGU kalt XC5',
  },
  {
    productKey: 'WME5011TX011 00V0V',
    customizedNumber: '85816',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 WGU warm XC5',
  },
  {
    productKey: 'WME5010TW011 00V0V',
    customizedNumber: '85817',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 WE1 kalt XC5',
  },
  {
    productKey: 'WME5011TW011 00V0V',
    customizedNumber: '85818',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 WE1 warm XC5',
  },
  {
    productKey: 'WME5010TE011 00V0V',
    customizedNumber: '85819',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 HT2 kalt XC5',
  },
  {
    productKey: 'WME5011TE011 00V0V',
    customizedNumber: '85820',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 HT2 warm XC5',
  },
  {
    productKey: 'WME5010TJ011 00V0V',
    customizedNumber: '85821',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 MB3 kalt XC5',
  },
  {
    productKey: 'WME5011TJ011 00V0V',
    customizedNumber: '85822',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 MB3 warm XC5',
  },
  {
    productKey: 'WME5010T8111 00V0V',
    customizedNumber: '85823',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 TE1 kalt XC5',
  },
  {
    productKey: 'WME5011T8111 00V0V',
    customizedNumber: '85824',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 TE1 warm XC5',
  },
  {
    productKey: 'WME5010T0011 00V0V',
    customizedNumber: '85831',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 80-G¾ kalt XC5',
  },
  {
    productKey: 'WME5011T0011 00V0V',
    customizedNumber: '85832',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 80-G¾ warm XC5',
  },
  {
    productKey: 'WME5010T1011 00V0V',
    customizedNumber: '85833',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-2,5 110-G¾ kalt XC5',
  },
  {
    productKey: 'WME5011T1011 00V0V',
    customizedNumber: '85834',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-2,5 110-G¾ warm XC5',
  },
  {
    productKey: 'WME5010T2011 00V0V',
    customizedNumber: '85835',
    type: 'KWZ',
    name: 'K WATER 5.5 Q3-4,0 130-G1 kalt XC5',
  },
  {
    productKey: 'WME5011T2011 00V0V',
    customizedNumber: '85836',
    type: 'WWZ',
    name: 'K WATER 5.5 Q3-4,0 130-G1 warm XC5',
  },
  {
    productKey: 'HMR5000G8420 00010',
    customizedNumber: '87001',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-A1 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G8520 00010',
    customizedNumber: '87003',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-A1 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G8820 00010',
    customizedNumber: '87004',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-A1 6,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G8920 00010',
    customizedNumber: '87005',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-A1 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GQ520 00010',
    customizedNumber: '87007',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-A1 5,2x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000GQ920 00010',
    customizedNumber: '87008',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-A1 6,0x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000G4020 00010',
    customizedNumber: '87020',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-IST 5,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G4520 00010',
    customizedNumber: '87023',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-IST 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G4620 00010',
    customizedNumber: '87025',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-IST 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G5020 00010',
    customizedNumber: '87030',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-IST 5,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G5420 00010',
    customizedNumber: '87031',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-IST 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G5520 00010',
    customizedNumber: '87033',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-IST 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G5620 00010',
    customizedNumber: '87035',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-IST 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GN520 00010',
    customizedNumber: '87037',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-IST 5,2x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000G6420 00010',
    customizedNumber: '87041',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-IST 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G6620 00010',
    customizedNumber: '87045',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-IST 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GO420 00010',
    customizedNumber: '87046',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-IST 5,0x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000GB520 00010',
    customizedNumber: '87050',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-TE1 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GC520 00010',
    customizedNumber: '87051',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-TE1 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GT520 00010',
    customizedNumber: '87055',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-TE1 5,2x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000GU520 00010',
    customizedNumber: '87056',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-TE1 5,2x3,0 WS HE XC',
  },
  {
    productKey: 'HMRHZY0GE120 00010',
    customizedNumber: '87062',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-DM1 5,2x1,5 KS HE XC',
  },
  {
    productKey: 'HMRHZY0GE620 00010',
    customizedNumber: '87065',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-DM1 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G0420 00010',
    customizedNumber: '87101',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-110 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G0520 00010',
    customizedNumber: '87103',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-110 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G0620 00010',
    customizedNumber: '87105',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-110 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GJ420 00010',
    customizedNumber: '87106',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 0,6-110 5,0x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000G1020 00010',
    customizedNumber: '87110',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 5,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G1420 00010',
    customizedNumber: '87111',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G1120 00010',
    customizedNumber: '87112',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 5,2x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G1520 00010',
    customizedNumber: '87113',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G1620 00010',
    customizedNumber: '87115',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GK420 00010',
    customizedNumber: '87116',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 5,0x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000GK520 00010',
    customizedNumber: '87117',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 5,2x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000GK620 00010',
    customizedNumber: '87118',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 1,5-110 6,0x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000G2020 00010',
    customizedNumber: '87130',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 5,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G2420 00010',
    customizedNumber: '87131',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G2120 00010',
    customizedNumber: '87132',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 5,2x1,5 KS HE XC',
  },
  {
    productKey: 'HMR5000G2520 00010',
    customizedNumber: '87133',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G2620 00010',
    customizedNumber: '87135',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000GL420 00010',
    customizedNumber: '87136',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 5,0x3,0 WS HE XC',
  },
  {
    productKey: 'HMR5000GL520 00010',
    customizedNumber: '87137',
    type: 'WMZ',
    name: 'KB HEAT 5.5R FR 2,5-130 5,2x3,0 WS HE XC',
  },
  {
    productKey: 'HMR500AG0490 00010',
    customizedNumber: '87201',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 0,6-110 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR500AG0590 00010',
    customizedNumber: '87203',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 0,6-110 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HMR500AG1095 00010',
    customizedNumber: '87210',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 1,5-110 5,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR500AG1195 00010',
    customizedNumber: '87212',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 1,5-110 5,2x1,5 KS HE XC',
  },
  {
    productKey: 'HMR500AG3490 00010',
    customizedNumber: '87221',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 1,5-130 5,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR500AG2095 00010',
    customizedNumber: '87230',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 2,5-130 5,0x1,5 KS HE XC',
  },
  {
    productKey: 'HMR500AG2195 00010',
    customizedNumber: '87232',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 2,5-130 5,2x1,5 KS HE XC',
  },
  {
    productKey: 'HMR500BG1495 00010',
    customizedNumber: '87240',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 1,5-110 5,0x3,0 KS HC XC',
  },
  {
    productKey: 'HMR500BGK495 00010',
    customizedNumber: '87241',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 1,5-110 5,0x3,0 WS HC XC',
  },
  {
    productKey: 'HMR500BG2495 00010',
    customizedNumber: '87242',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 2,5-130 5,0x3,0 KS HC XC',
  },
  {
    productKey: 'HMR500BGL495 00010',
    customizedNumber: '87243',
    type: 'WMZ',
    name: 'KB HEAT 5.5R US 2,5-130 5,0x3,0 WS HC XC',
  },
  {
    productKey: 'HBR500AG4D95 00050',
    customizedNumber: '87251',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 3,5-150 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG4995 00050',
    customizedNumber: '87252',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 3,5-150 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG6D95 00050',
    customizedNumber: '87259',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 6,0-150 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG6995 00050',
    customizedNumber: '87260',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 6,0-150 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG8995 00050',
    customizedNumber: '87268',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 10-200 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG5D95 00050',
    customizedNumber: '87275',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 3,5-260 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG5995 00050',
    customizedNumber: '87276',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 3,5-260 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG7D95 00050',
    customizedNumber: '87283',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 6,0-260 5,2x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG7995 00050',
    customizedNumber: '87284',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 6,0-260 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HBR500AG9995 00050',
    customizedNumber: '87292',
    type: 'WMZ',
    name: 'K HEAT 5.5 R US 10-300 6,0x3,0 KS HE XC',
  },
  {
    productKey: 'HMR5000G8820 0001V',
    customizedNumber: '88004',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 1,5-A1 6,0x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR5000G4020 0001V',
    customizedNumber: '88020',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 0,6-IST 5,0x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR5000G5020 0001V',
    customizedNumber: '88030',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 1,5-IST 5,0x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR5000G5620 0001V',
    customizedNumber: '88035',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 1,5-IST 6,0x3,0 KS HE XC5',
  },
  {
    productKey: 'HMR5000G6420 0001V',
    customizedNumber: '88041',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 2,5-IST 5,0x3,0 KS HE XC5',
  },
  {
    productKey: 'HMR5000G1020 0001V',
    customizedNumber: '88110',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 1,5-110 5,0x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR5000G1120 0001V',
    customizedNumber: '88112',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 1,5-110 5,2x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR5000G2020 0001V',
    customizedNumber: '88130',
    type: 'WMZ',
    name: 'K HEAT 5.5R FR 2,5-130 5,0x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR500AG1095 0001V',
    customizedNumber: '88210',
    type: 'WMZ',
    name: 'K HEAT 5.5R US 1,5-110 5,0x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR500AG1195 0001V',
    customizedNumber: '88212',
    type: 'WMZ',
    name: 'K HEAT 5.5R US 1,5-110 5,2x1,5 KS HE XC5',
  },
  {
    productKey: 'HMR500AG2095 0001V',
    customizedNumber: '88230',
    type: 'WMZ',
    name: 'K HEAT 5.5R US 2,5-130 5,0x1,5 KS HE XC5',
  },
  {
    productKey: 'WFZ.B6-7',
    customizedNumber: '92081',
    type: 'ZUBE',
    name: 'Rosette 125mm für IST 75mm AMS',
  },
  {
    productKey: 'WFZ.B6-8',
    customizedNumber: '92085',
    type: 'ZUBE',
    name: 'Tubus für IST 75mm AMS',
  },
  {
    productKey: 'WMM400104001 00V00',
    customizedNumber: '92194',
    type: 'WWZ',
    name: 'WMM4-Q3 2,5m³/h IST hot QUN',
  },
  {
    productKey: 'WFZ2.SN2240',
    customizedNumber: '92316',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ verchromt 1" 40mm',
  },
  {
    productKey: 'WFZ2.VN25',
    customizedNumber: '92318',
    type: 'ZUBE',
    name: 'Verlängerung VZ 25mm  verchromt (10 St.)',
  },
  {
    productKey: 'WFZ2.FN15',
    customizedNumber: '92353',
    type: 'ZUBE',
    name: 'Fließrichtungswandler VZ ½" verchromt',
  },
  {
    productKey: 'WFZ2.FN18',
    customizedNumber: '92354',
    type: 'ZUBE',
    name: 'Fließrichtungsw. VZ ¾" verchromt',
  },
  {
    productKey: 'WFZ2.FN22',
    customizedNumber: '92355',
    type: 'ZUBE',
    name: 'Fließrichtungswandler VZ 1" verchromt',
  },
  {
    productKey: 'WMM400006001 00V00',
    customizedNumber: '92500',
    type: 'KWZ',
    name: 'WMM4-Q3 2,5m³/h A34 cold QUN',
  },
  {
    productKey: 'WMM400106001 00V00',
    customizedNumber: '92502',
    type: 'WWZ',
    name: 'WMM4-Q3 2,5m³/h A34 hot QUN',
  },
  {
    productKey: 'WMM400004001 00V00',
    customizedNumber: '93010',
    type: 'KWZ',
    name: 'WMM4-Q3 2,5m³/h IST cold QUN',
  },
  {
    productKey: 'WME5001TJ011 00V00',
    customizedNumber: '93027',
    type: 'KWZ',
    name: 'WME5-Qeßkapsel M 307/1 warm ohne Rosette',
  },
  {
    productKey: 'BBV5521',
    customizedNumber: '93324',
    type: 'ZUBE',
    name: 'Kapselgehäuse IST Austausch VZ/BWZ QUN',
  },
  {
    productKey: 'F428090010',
    customizedNumber: '93338',
    type: 'ZUBE',
    name: 'Flachdichtung A16,8/B24',
  },
  {
    productKey: 'FKL0013',
    customizedNumber: '93339',
    type: 'ZUBE',
    name: 'STEUERKABEL COM EINGANG 4POLIG 1m',
  },
  {
    productKey: 'FKM0134',
    customizedNumber: '93340',
    type: 'ZUBE',
    name: 'Zählerersatzstück 300-G2 Edelstahl TW',
  },
  {
    productKey: 'BOZ5011',
    customizedNumber: '93341',
    type: 'ZUBE',
    name: 'Beipack für DFS Q heat 5 AMS',
  },
  {
    productKey: 'WME5001TE011 00V00',
    customizedNumber: '97114',
    type: 'WWZ',
    name: 'WME5-Q3 2,5m³/h HT2 hot AMR-WB-C QUN',
  },
  {
    productKey: 'BOZ5044',
    customizedNumber: '98321',
    type: 'ZUBE',
    name: 'O-Ringe Schiebestück UP 3080 WG',
  },
  {
    productKey: 'FKM0022',
    customizedNumber: '98340',
    type: 'ZUBE',
    name: 'Verschraubung 1"/1"',
  },
  {
    productKey: 'HMXIK002 001',
    customizedNumber: '98352',
    type: 'ZUBE',
    name: 'Einbausatz QDS (VL-KH, RL-VS) R½xG¾',
  },
  {
    productKey: 'HMXIK002 002',
    customizedNumber: '98353',
    type: 'ZUBE',
    name: 'Einbausatz QDS (VL-KH, RL-VS) R¾xG¾',
  },
  {
    productKey: 'HMXIK002 003',
    customizedNumber: '98354',
    type: 'ZUBE',
    name: 'Einbausatz QDS (VL-KH, RL-VS) R1xG¾',
  },
  {
    productKey: 'HMXIK002 004',
    customizedNumber: '98355',
    type: 'ZUBE',
    name: 'Einbausatz QDS (VL-KH, RL-VS) R1xG1',
  },
  {
    productKey: 'HMXIK002 005',
    customizedNumber: '98356',
    type: 'ZUBE',
    name: 'Einbausatz QDS (VL-KH, RL-VS) R¾xG1',
  },
  {
    productKey: 'HMXIK003 001',
    customizedNumber: '98357',
    type: 'ZUBE',
    name: 'Adaptersatz G¾xG1 (110mm)',
  },
  {
    productKey: 'FKK0034',
    customizedNumber: '98421',
    type: 'ZUBE',
    name: 'Steckblende für  HKV Gen. 5',
  },
  {
    productKey: 'FKK0173',
    customizedNumber: '98422',
    type: 'ZUBE',
    name: 'Ausrichtungsteil A34 Qwater 5.5',
  },
  {
    productKey: 'FKL0012',
    customizedNumber: '98423',
    type: 'ZUBE',
    name: 'STEUERKABEL COM AUSGANG 4POLIG 3m',
  },
  {
    productKey: 'FKK0184',
    customizedNumber: '98424',
    type: 'ZUBE',
    name: 'Klemmring schwarz RW',
  },
  {
    productKey: 'FKS0034',
    customizedNumber: '98425',
    type: 'ZUBE',
    name: 'Dichtring f. Qwater5.5 Typ A34 (M77x1,5)',
  },
  {
    productKey: 'FNS0001',
    customizedNumber: '98426',
    type: 'ZUBE',
    name: 'Kunststoffplombe Twister blau 250    W',
  },
  {
    productKey: 'WFZ.BS-AL',
    customizedNumber: '98427',
    type: 'ZUBE',
    name: 'Plombensatz WFZ16.AL (10St/Pack)',
  },
  {
    productKey: 'WFZ.BS-MO',
    customizedNumber: '98428',
    type: 'ZUBE',
    name: 'Ersatzplombierset WFZ16.MO (10St/Pack)',
  },
  {
    productKey: 'WFZ.MBUSSET',
    customizedNumber: '98429',
    type: 'ZUBE',
    name: 'M-Bus-Anschluß-Set f. Megatron2',
  },
  {
    productKey: 'WFZ.P',
    customizedNumber: '98430',
    type: 'ZUBE',
    name: 'Selflockplombe orange (1 Pak á 100 St)',
  },
  {
    productKey: 'WFZ.R2',
    customizedNumber: '98431',
    type: 'ZUBE',
    name: '1 Paar Verschraubung ½" Überwurfm.¾"',
  },
  {
    productKey: 'WFZ.R2-1',
    customizedNumber: '98432',
    type: 'ZUBE',
    name: '2 Stk. Verschraubung ¾" Überwurfm.1"',
  },
  {
    productKey: 'WFZ.W',
    customizedNumber: '98433',
    type: 'ZUBE',
    name: 'Anbausatz kpl. für Waschtisch-WZ',
  },
  {
    productKey: 'WFZ2.MS',
    customizedNumber: '98434',
    type: 'ZUBE',
    name: 'Mittelstück komplett',
  },
  {
    productKey: 'WFZ2.SN1540',
    customizedNumber: '98435',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ  verchromt  ½" 40mm',
  },
  {
    productKey: 'WFZ2.SN1590',
    customizedNumber: '98436',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ verchromt ½" 90mm',
  },
  {
    productKey: 'WFZ2.SN1840',
    customizedNumber: '98437',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ verchromt ¾" 40mm',
  },
  {
    productKey: 'WFZ2.SN1890',
    customizedNumber: '98438',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ verchromt ¾" 90mm',
  },
  {
    productKey: 'WFZ2.SN2240',
    customizedNumber: '98439',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ verchromt 1" 40mm',
  },
  {
    productKey: 'WFZ2.SN2290',
    customizedNumber: '98440',
    type: 'ZUBE',
    name: 'Anschluß-Set VZ verchromt 1" 90mm',
  },
  {
    productKey: 'WFZ2.SR15',
    customizedNumber: '98441',
    type: 'ZUBE',
    name: 'Universalsteigrohr B ½" (1 Pak a 5 St)',
  },
  {
    productKey: 'WFZ2.SR18',
    customizedNumber: '98442',
    type: 'ZUBE',
    name: 'Universalsteigrohr B ¾" und 1" (5 St)',
  },
  {
    productKey: 'WFZ2.VN25',
    customizedNumber: '98443',
    type: 'ZUBE',
    name: 'Verlängerung VZ 25mm  verchromt (10 St.)',
  },
  {
    productKey: 'WFZW.B1',
    customizedNumber: '98444',
    type: 'ZUBE',
    name: 'Rosette rund, verchromt, 140mm',
  },
  {
    productKey: 'WME.EINPUTZ1',
    customizedNumber: '98445',
    type: 'ZUBE',
    name: 'Kunststoffeinputzhilfe komplett',
  },
  {
    productKey: 'WME.FLDICHT',
    customizedNumber: '98446',
    type: 'ZUBE',
    name: 'Flachdichtung 56 x 47 x 2,1',
  },
  {
    productKey: 'WME.G20/H',
    customizedNumber: '98447',
    type: 'ZUBE',
    name: 'EAT Länge 80mm IG ¾"',
  },
  {
    productKey: 'WME.G20/OV/H',
    customizedNumber: '98448',
    type: 'ZUBE',
    name: 'EAT 80mm Ig ¾" o. Verschl.,Dichtung',
  },
  {
    productKey: 'FKS0007',
    customizedNumber: '98449',
    type: 'ZUBE',
    name: 'Profildichtung D 56,5 für MK Koax',
  },
  {
    productKey: 'WME.L15/OV/H',
    customizedNumber: '98450',
    type: 'ZUBE',
    name: 'EAT-Gehäuse AG½, 110mm Löt 15mm',
  },
  {
    productKey: 'WME.L18/OV/H',
    customizedNumber: '98451',
    type: 'ZUBE',
    name: 'EAT ¾"AG/18 mm Löt HWW ohne Verschluß',
  },
  {
    productKey: 'WME.L22/H',
    customizedNumber: '98452',
    type: 'ZUBE',
    name: 'EAT Länge 130mm 22 Löt H',
  },
  {
    productKey: 'WME.L22/OV/H',
    customizedNumber: '98453',
    type: 'ZUBE',
    name: 'EAT-Geh. G¾, 130mm Löt 22mm o.Verschl.',
  },
  {
    productKey: 'WME.PRODICHT',
    customizedNumber: '98454',
    type: 'ZUBE',
    name: 'Profildichtung 57x46x4 f. EAS u. VAS2',
  },
  {
    productKey: 'WMZ.DR',
    customizedNumber: '98455',
    type: 'ZUBE',
    name: 'Distanzring mechanische MK-Wasserzähler',
  },
  {
    productKey: 'WTZ.BAT',
    customizedNumber: '98456',
    type: 'ZUBE',
    name: 'Hauptbatterie Qnode',
  },
  {
    productKey: 'WZM-V110',
    customizedNumber: '98457',
    type: 'ZUBE',
    name: 'Verlängerung 80 mm G¾" auf 110 mm G1"',
  },
  {
    productKey: 'WZM-V130',
    customizedNumber: '98458',
    type: 'ZUBE',
    name: 'Verlängerung110mm auf 130mm (G¾B)',
  },
  {
    productKey: 'WZM-V165',
    customizedNumber: '98459',
    type: 'ZUBE',
    name: 'Verlängerung 110mm auf 165mm (G¾B)',
  },
  {
    productKey: 'WZM-V190',
    customizedNumber: '98460',
    type: 'ZUBE',
    name: 'Verlängerung-110mm auf 190mm (G¾B)',
  },
  {
    productKey: 'HMXIK003 005',
    customizedNumber: '98461',
    type: 'ZUBE',
    name: 'Verlängerung-110mm auf 190mm (G¾BxG1)',
  },
  {
    productKey: 'WMXI.KCR1 001',
    customizedNumber: '98463',
    type: 'ZUBE',
    name: 'Rosette rund mit Tubus - Chromoptik QUN',
  },
  {
    productKey: 'WMXI.KCR1 002',
    customizedNumber: '98464',
    type: 'ZUBE',
    name: 'Innenverlängerung Tubus - Chromoptik QUN',
  },
  {
    productKey: 'WMXI.KCR1 003',
    customizedNumber: '98465',
    type: 'ZUBE',
    name: 'Außenverlängerung Tubus - Chromoptik QUN',
  },
  {
    productKey: 'WMXI.KCR1 004',
    customizedNumber: '98466',
    type: 'ZUBE',
    name: 'Rosette quad. mit Tubus - Chromoptik QUN',
  },
  {
    productKey: 'WMXI.KBL1 001',
    customizedNumber: '98467',
    type: 'ZUBE',
    name: 'Rosette rund mit Tubus - weiß QUN',
  },
  {
    productKey: 'WMXI.KBL1 002',
    customizedNumber: '98468',
    type: 'ZUBE',
    name: 'Innenverlängerung Tubus - weiß QUN',
  },
  {
    productKey: 'WMXI.KBL1 003',
    customizedNumber: '98469',
    type: 'ZUBE',
    name: 'Außenverlängerung Tubus - weiß QUN',
  },
  {
    productKey: 'WMXI.KBL1 004',
    customizedNumber: '98470',
    type: 'ZUBE',
    name: 'Rosette quad. mit Tubus - weiß QUN',
  },
  {
    productKey: 'WMXI.KCR1 009',
    customizedNumber: '98473',
    type: 'ZUBE',
    name: 'Tubus einzeln - Chromoptik QUN',
  },
  {
    productKey: 'WFZ.B7-1',
    customizedNumber: '98474',
    type: 'ZUBE',
    name: 'Blendenset Minol Monoblock - Chrom ZEN',
  },
  {
    productKey: 'WFZ.B7-2',
    customizedNumber: '98475',
    type: 'ZUBE',
    name: 'Blendenset Minol Duoblock - Chrom ZEN',
  },
  {
    productKey: 'BOZ5043',
    customizedNumber: '98526',
    type: 'ZUBE',
    name: 'O-Ringe Schiebestück UP 3000 AMS',
  },
  {
    productKey: 'HMXIK003 003',
    customizedNumber: '98530',
    type: 'ZUBE',
    name: 'Verl.-Satz  G¾xG¾ 110 auf 130 mm',
  },
  {
    productKey: 'HMXIK003 004',
    customizedNumber: '98531',
    type: 'ZUBE',
    name: 'Verl.-Satz G¾xG¾ 110 auf 165 mm',
  },
  {
    productKey: 'WZM-V105',
    customizedNumber: '98532',
    type: 'ZUBE',
    name: 'Verlängerung G ¾" x G ¾" 25mm',
  },
  {
    productKey: 'WZM-W105',
    customizedNumber: '98533',
    type: 'ZUBE',
    name: 'Verlängerung G ¾" x G 1" 12,5mm',
  },
  {
    productKey: 'WZM-V145',
    customizedNumber: '98534',
    type: 'ZUBE',
    name: 'Verlängerung G ¾" x G ¾" 35mm',
  },
  {
    productKey: 'WZM-W130',
    customizedNumber: '98535',
    type: 'ZUBE',
    name: 'Verlängerung G ¾" x G 1" 20 mm',
  },
  {
    productKey: 'WZM-W190',
    customizedNumber: '98536',
    type: 'ZUBE',
    name: 'Verlängerung G ¾" x G ¾" 80mm',
  },
  {
    productKey: 'HMXIP001 002',
    customizedNumber: '98538',
    type: 'ZUBE',
    name: 'Anschlusskabel 4-adrig (Imp.out)',
  },
  {
    productKey: 'HMXIP001 003',
    customizedNumber: '98539',
    type: 'ZUBE',
    name: 'Anschlusskabel 4-adrig (Imp.in)',
  },
  {
    productKey: 'FKM0133',
    customizedNumber: '98566',
    type: 'ZUBE',
    name: 'Zählerersatzstück 260-G1½ Edelstahl TW',
  },
  {
    productKey: 'FKM0132',
    customizedNumber: '98568',
    type: 'ZUBE',
    name: 'Zählerersatzstück 150-G1½ Edelstahl TW',
  },
  {
    productKey: 'HMXIP002 001',
    customizedNumber: '98576',
    type: 'ZUBE',
    name: 'Hakenschlüssel verstellbar',
  },
  {
    productKey: '591532 0',
    customizedNumber: '98577',
    type: 'ZUBE',
    name: 'WMZ-Ersatzstück / Qn 10,0 / senkrecht',
  },
  {
    productKey: 'BBV5522',
    customizedNumber: '98643',
    type: 'ZUBE',
    name: 'Badewannen-WZ Anschluß ams ¾',
  },
  {
    productKey: 'F13001-1102',
    customizedNumber: '98644',
    type: 'ZUBE',
    name: 'Anschlussarmatur BWZ ¾"',
  },
  {
    productKey: 'F13011-2070',
    customizedNumber: '98738',
    type: 'ZUBE',
    name: 'Montageschlüssel VZ veredelt',
  },
  {
    productKey: 'F13011-2055',
    customizedNumber: '98748',
    type: 'ZUBE',
    name: 'Klapprosette 65mm',
  },
  {
    productKey: 'F13011-2056',
    customizedNumber: '98749',
    type: 'ZUBE',
    name: 'Klapprosette 85mm',
  },
  {
    productKey: 'FBCRAA/KS',
    customizedNumber: '98751',
    type: 'ZUBE',
    name: 'Backup Batterie WT*16; Lith.CRAA Kab/Ste',
  },
  {
    productKey: 'WMDH0000C001 Z0V00',
    customizedNumber: '98779',
    type: 'KWZ',
    name: 'WMDH-Q3 6,3m³/h 260mm DN25 MTK-HWX cold',
  },
  {
    productKey: 'WMMHZY10IM05 Z5V00',
    customizedNumber: '98927',
    type: 'WWZ',
    name: 'WWZ Q3-2,5 80-Steck POV MIN',
  },
  {
    productKey: 'FNM0011',
    customizedNumber: '98946',
    type: 'ZUBE',
    name: 'Rändelmutter TF allmess rot',
  },
  {
    productKey: 'FKK0221',
    customizedNumber: '98966',
    type: 'ZUBE',
    name: 'Einlaufbuchse Minol MB2',
  },
  {
    productKey: 'FKK0222',
    customizedNumber: '98968',
    type: 'ZUBE',
    name: 'Auslaufbuchse Minol MB2',
  },
  {
    productKey: 'WFZ.R110',
    customizedNumber: '98971',
    type: 'ZUBE',
    name: 'Zählerersatzstück ¾" 110mm DN 15',
  },
  {
    productKey: '50590986H 4',
    customizedNumber: '99000',
    type: 'WMZ',
    name: 'WMWP-VMT qp 80 H/V DN125 250mm 100l/Imp',
  },
  {
    productKey: '50590988H 4',
    customizedNumber: '99001',
    type: 'WMZ',
    name: 'WMWP-VMT qp 200 H/V DN200 350mm 100l/Imp',
  },
  {
    productKey: '593812 0',
    customizedNumber: '99002',
    type: 'ZUBE',
    name: 'Verbindungskabel für WMZ 2.polig',
  },
  {
    productKey: 'FKM0131',
    customizedNumber: '99926',
    type: 'ZUBE',
    name: 'Zählerersatzstück 190-G1 Edelstahl TW',
  },
  {
    productKey: 'WFZ.R130',
    customizedNumber: '99929',
    type: 'ZUBE',
    name: 'Zählerersatzstück 1" 130mm DN20',
  },
  {
    productKey: '591530 0',
    customizedNumber: '99944',
    type: 'ZUBE',
    name: 'Spülrohr 150 mm, G 5/4" (vert. Einb.)',
  },
];

const srtTypeList = [
  {
    name: 'Thermostatkopf SRT V1.5',
    productKey: '105689',
    customizedNumber: '42001',
  },
  {
    name: 'Thermostatkopf SRT V1.5',
    productKey: '105906',
    customizedNumber: '42001',
  },
  {
    name: 'Thermostat / SRT inkl. Batterie',
    productKey: '105456',
    customizedNumber: '42000',
  },
  {
    name: 'SRT',
    productKey: '106244',
    customizedNumber: '42001',
  },
];

const batteryPackTypeList = [
  {
    name: 'Batterie SRT MB04XL',
    productKey: '105699',
    customizedNumber: '42006',
  },
  {
    name: 'Batterie SRT MB04XL',
    productKey: '105979',
    customizedNumber: '42006',
  },
  {
    name: 'Batterie SRT MB04',
    productKey: '105227',
    customizedNumber: '42005',
  },
];

const rawArticleNumbersList = {
  GATEWAY: submeteringDeviceMappingList,
  SRT: srtTypeList,
  BATTERY_PACK: batteryPackTypeList,
  ADAPTER: adapterTypeList,
};

const smartHeatingCustomizedNumbers = [
  ...adapterTypeList.map((adapter) => adapter.customizedNumber),
  ...srtTypeList.map((srt) => srt.customizedNumber),
  ...batteryPackTypeList.map((batteryPack) => batteryPack.customizedNumber),
];

export default rawArticleNumbersList;
export { smartHeatingCustomizedNumbers };
